let hsData = [
  {
    "Record ID": 1,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "360 Communities",
    "Address": "501 E Highway 13",
    "Suite (Ste.) or Apartment (Apt.) number": "Suite 112",
    "City": "Burnsville",
    "State": "MN",
    "Zip Code": 55337,
    "County": "Dakota",
    "Main phone number": "952-985-5300",
    "Crisis Line Phone Number": "651-405-1500",
    "Organization website": "www.360communities.org",
    "Organization Email": "",
    "Hours of operation": "24 hours, 7 days a week",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Safety, support and advocacy services. Trained advocates offer emotional support, safety planning, referrals to community resources and help in navigating the court system."
  },
  {
    "Record ID": 2,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "360 Communities - Lewis House Eagan",
    "Address": "n/a",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Eagan",
    "State": "MN",
    "Zip Code": null,
    "County": "Dakota",
    "Main phone number": "952-985-5300",
    "Crisis Line Phone Number": "651-452-7288",
    "Organization website": "360communities.org/violence-prevention/lewis-house/",
    "Organization Email": "",
    "Hours of operation": "24 hours, 7 days a week",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Safety, support, and advocacy services for women, children, and families. Trained advocates offer emotional support, safety planning, referrals to community resources and help in navigating the court system."
  },
  {
    "Record ID": 3,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Alexandra House",
    "Address": "10065 3rd St NE",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Blaine",
    "State": "MN",
    "Zip Code": 55434,
    "County": "Statewide",
    "Main phone number": "763-780-2330",
    "Crisis Line Phone Number": "1-866-223-1111",
    "Organization website": "www.alexandrahouse.org",
    "Organization Email": "",
    "Hours of operation": "24 hours, 7 days a week",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Victims of domestic or sexual violence across the state of Minnesota.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Spanish interpreters on-site; other language interpreters available by appointment.",
    "Please provide a description of services your organization offers": "Confidential domestic or sexual violence services.  24-hour emergency shelter, crisis intervention, advocacy, support services, safety planning, house resources and referrals, support groups and a children’s program."
  },
  {
    "Record ID": 4,
    "Type of Service": "Vision Services",
    "Name of Organization": "Allina Clinic",
    "Address": "7920 Old Cedar Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Bloomington",
    "State": "MN",
    "Zip Code": 55425,
    "County": "Hennepin",
    "Main phone number": "952-428-1800",
    "Crisis Line Phone Number": "",
    "Organization website": "www.allinahealth.org",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 7:30 a.m. - 5:00 p.m",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Comprehensive eye exams, including newborn and infant screenings, diabetic eye exams; evaluation and treatment of eye infections and injuries, cataracts, glaucoma and macular degeneration; contact lens fitting, laser surgery."
  },
  {
    "Record ID": 5,
    "Type of Service": "Vision Services",
    "Name of Organization": "Allina Clinic",
    "Address": "1324 Fifth Street N.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "New Ulm",
    "State": "MN",
    "Zip Code": 56073,
    "County": "Brown",
    "Main phone number": "507-217-5011",
    "Crisis Line Phone Number": "",
    "Organization website": "www.allinahealth.org",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Comprehensive eye exams, including newborn and infant screenings, diabetic eye exams; evaluation and treatment of eye infections and injuries, cataracts, glaucoma and macular degeneration; contact lens fitting, laser surgery."
  },
  {
    "Record ID": 6,
    "Type of Service": "Vision Services",
    "Name of Organization": "Allina Clinic",
    "Address": "100 State Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Faribault",
    "State": "MN",
    "Zip Code": 55021,
    "County": "Rice",
    "Main phone number": "507-334-3921",
    "Crisis Line Phone Number": "",
    "Organization website": "www.allinahealth.org",
    "Organization Email": "",
    "Hours of operation": "Mon - Thurs 7:30am - 8pm Fri 7:30am - 5pm Sat 9:00am - 12:00pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Comprehensive eye exams, including newborn and infant screenings, diabetic eye exams; evaluation and treatment of eye infections and injuries, cataracts, glaucoma and macular degeneration; contact lens fitting, laser surgery."
  },
  {
    "Record ID": 7,
    "Type of Service": "Vision Services",
    "Name of Organization": "Allina Clinic",
    "Address": "701 S. Dellwood St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Cambridge",
    "State": "MN",
    "Zip Code": 55008,
    "County": "Isanti",
    "Main phone number": "763-689-7700",
    "Crisis Line Phone Number": "",
    "Organization website": "www.allinahealth.org",
    "Organization Email": "",
    "Hours of operation": "Mon., Wed., Thurs. 7:30 a.m. - 5:30 p.m. Tues. 8:00 a.m. - 7:00 p.m. Fri. 8:00 a.m. - 5:30 p.m. Sat. 8:00 a.m. - noon",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Comprehensive eye exams, including newborn and infant screenings, diabetic eye exams; evaluation and treatment of eye infections and injuries, cataracts, glaucoma and macular degeneration; contact lens fitting, laser surgery."
  },
  {
    "Record ID": 8,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Associated Clinic of Psychology",
    "Address": "6950 W. 146th St.",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 100",
    "City": "Apple Valley",
    "State": "MN",
    "Zip Code": 55124,
    "County": "Dakota",
    "Main phone number": "952-432-1484",
    "Crisis Line Phone Number": "",
    "Organization website": "www.acp-mn.com",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Individual or Group therapy, Family Counseling, Marriage/Relationship Counseling, Neuropsychological/Psychological Testing, Psychiatric Evaluations, Medication Management,  In-home therapy or services and long-term care services.  Childrenï¿½s Therapeutic Services and Supports (CTSS), Adult Rehabilitative Mental Health Services (ARMHS), Somali Youth Family Services."
  },
  {
    "Record ID": 9,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Associated Clinic of Psychology",
    "Address": "4027 County Rd 25",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55416,
    "County": "Hennepin",
    "Main phone number": "612-925-6033",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.acp-mn.com/",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 8:00 a.m. - 9:00 p.m.; Sat.: 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Individual or group therapy, family counseling, marriage/relationship Counseling, neuropsychological/psychological testing, psychiatric evaluations, medication management,  in-home therapy/services and long-term care services.  Children’s Therapeutic Services and Supports (CTSS), Adult Rehabilitative Mental Health Services (ARMHS)."
  },
  {
    "Record ID": 10,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Associated Clinic of Psychology",
    "Address": "6200 Shingle Creek Pkwy",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 350",
    "City": "Brooklyn Center",
    "State": "MN",
    "Zip Code": 55430,
    "County": "Hennepin",
    "Main phone number": "763-503-8560",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.acp-mn.com/",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 8:00 a.m. - 9:00 p.m.;  Sat.: 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Individual or group therapy, family counseling, marriage/relationship Counseling, neuropsychological/psychological testing, psychiatric evaluations, medication management,  in-home therapy/services and long-term care services.  Children’s Therapeutic Services and Supports (CTSS), Adult Rehabilitative Mental Health Services (ARMHS)."
  },
  {
    "Record ID": 11,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Associated Clinic of Psychology",
    "Address": "1155 Ford Road",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. B",
    "City": "St. Louis Park",
    "State": "MN",
    "Zip Code": 55426,
    "County": "Hennepin",
    "Main phone number": "952-378-1800",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.acp-mn.com/",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 8:00 a.m. - 9:00 p.m.;  Sat.: 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Individual or group therapy, family counseling, marriage/relationship Counseling, neuropsychological/psychological testing, psychiatric evaluations, medication management,  in-home therapy/services and long-term care services.  Children’s Therapeutic Services and Supports (CTSS), Adult Rehabilitative Mental Health Services (ARMHS)."
  },
  {
    "Record ID": 12,
    "Type of Service": "Vision Services",
    "Name of Organization": "Associated Eye Care",
    "Address": "2950 Curve Crest Blvd W.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Stillwater",
    "State": "MN",
    "Zip Code": 55082,
    "County": "Washington",
    "Main phone number": "651-275-3000",
    "Crisis Line Phone Number": "",
    "Organization website": "www.associatedeyecare.com",
    "Organization Email": "",
    "Hours of operation": "Mon. 7:30 a.m. - 7:00 p.m. Tues. 7:30 a.m. - 5:00 p.m. Wed. 7:30 a.m. - 5:00p.m. Thurs. 7:30 a.m. - 7:00 p.m. Fri. 7:30 a.m. - 5:00 p.m. Sat. 8:00 a.m. - 12:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Eye exams, glaucoma and diabetes related problems, dry eye, surgery, LASIK, cataract surgery, macular degeneration, contact lenses and glasses, and other issues."
  },
  {
    "Record ID": 13,
    "Type of Service": "Vision Services",
    "Name of Organization": "Associated Eye Care",
    "Address": "14688 Everton Ave. N.",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 106",
    "City": "Hugo",
    "State": "MN",
    "Zip Code": 55038,
    "County": "Washington",
    "Main phone number": "651-275-3000",
    "Crisis Line Phone Number": "",
    "Organization website": "www.associatedeyecare.com",
    "Organization Email": "",
    "Hours of operation": "Mon., Tues., Thurs., and Fri. 7:30 a.m. - 5:00 p.m. Wed. 7:30 a.m. - 7:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Eye exams, glaucoma and diabetes related problems, dry eye, surgery, LASIK, cataract surgery, macular degeneration, contact lenses and glasses, and other issues."
  },
  {
    "Record ID": 14,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Behavioral Healthcare Providers (BHP)",
    "Address": "1405 N Lilac Drive",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 151",
    "City": "Golden Valley",
    "State": "MN",
    "Zip Code": null,
    "County": "Hennepin",
    "Main phone number": "763-525-1746",
    "Crisis Line Phone Number": "",
    "Organization website": "www.bhpcare.com",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. - 4:30 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "A network of more than 5,000 behavioral providers, programs and hospitals offering mental health and chemical health services. Inpatient and outpatient mental health care. Children’s Therapeutic Services and Supports (CTSS), Adult Rehabilitative Mental Health Services (ARMHS),  Somali Youth Family Services."
  },
  {
    "Record ID": 15,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Canvas Health",
    "Address": "1550 E 78th",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Richfield",
    "State": "MN",
    "Zip Code": 55432,
    "County": "Hennepin",
    "Main phone number": "(612) 676-1604",
    "Crisis Line Phone Number": "1-800-273-8255",
    "Organization website": "www.canvashealth.org",
    "Organization Email": "",
    "Hours of operation": "Mon-Thurs: 8:00 a.m. - 5:00 p.m. Friday: 9:00 a.m. - 12:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Somali, Ibo on-site",
    "Please provide a description of services your organization offers": "Childrenï¿½s Therapeutic Services and Supports (CTSS) and Adult Rehabilitative Mental Health Services (ARMHS) services provided in Somali and Ibo."
  },
  {
    "Record ID": 16,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Casa de Esperanza",
    "Address": "PO Box 40115",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55104,
    "County": "Hennepin",
    "Main phone number": "651-646-5553",
    "Crisis Line Phone Number": "651-772-1611",
    "Organization website": "www.casadeesperanza.org",
    "Organization Email": "",
    "Hours of operation": "24 hours, 7 days a week",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Spanish on-site; interpreter services for other languages upon request.",
    "Please provide a description of services your organization offers": "Emergency shelter for domestic violence victims, community advocacy program for Latino victims and a 24-hour bilingual domestic violence crisis line."
  },
  {
    "Record ID": 17,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Central Minnesota Mental Health Center",
    "Address": "1321 13th St. N.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Cloud",
    "State": "MN",
    "Zip Code": 56303,
    "County": "Stearns",
    "Main phone number": "320-252-5010",
    "Crisis Line Phone Number": "320-253-5555",
    "Organization website": "cmmhc.org",
    "Organization Email": "",
    "Hours of operation": "Varies by location",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Dependent on program.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Adult mental health outpatient services, rehabilitative services, crisis services, and residential services. Outpatient and inpatient chemical dependency treatment. Children and family counseling, medication management and support services."
  },
  {
    "Record ID": 18,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Central Minnesota Mental Health Center",
    "Address": "308 12th Ave S",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Buffalo",
    "State": "MN",
    "Zip Code": 55313,
    "County": "Wright",
    "Main phone number": "763-682-4400",
    "Crisis Line Phone Number": "320-253-5555",
    "Organization website": "cmmhc.org",
    "Organization Email": "",
    "Hours of operation": "",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Adult mental health outpatient services, rehabilitative services, crisis services, and residential services. Outpatient and inpatient chemical dependency treatment. Children and family counseling, medication management and support services."
  },
  {
    "Record ID": 19,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Central Minnesota Mental Health Center",
    "Address": "407 Washington St",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Monticello",
    "State": "MN",
    "Zip Code": 55362,
    "County": "Sherburne",
    "Main phone number": "763-295-4001",
    "Crisis Line Phone Number": "320-253-5555",
    "Organization website": "cmmhc.org",
    "Organization Email": "",
    "Hours of operation": "",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Adult mental health outpatient services, rehabilitative services, crisis services, and residential services. Outpatient and inpatient chemical dependency treatment. Children and family counseling, medication management and support services."
  },
  {
    "Record ID": 20,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Central Minnesota Mental Health Center",
    "Address": "411 3rd Street N.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Waite Park",
    "State": "MN",
    "Zip Code": 56387,
    "County": "Stearns",
    "Main phone number": "320-230-0611",
    "Crisis Line Phone Number": "320-253-5555",
    "Organization website": "cmmhc.org",
    "Organization Email": "",
    "Hours of operation": "",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Adult mental health outpatient services, rehabilitative services, crisis services, and residential services. Outpatient and inpatient chemical dependency treatment. Children and family counseling, medication management and support services."
  },
  {
    "Record ID": 21,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Childhelp National Child Abuse Hotline",
    "Address": "",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "",
    "State": "",
    "Zip Code": null,
    "County": "Statewide",
    "Main phone number": "",
    "Crisis Line Phone Number": "1-800-422-4453",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "24 hours, 7 days a week",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "24-hour crisis intervention and counseling hotline to prevent child abuse. Offers short-term counseling, information and referral to local resources."
  },
  {
    "Record ID": 22,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "CLUES (Comunidades Latinas Unidas en Servicio)",
    "Address": "797 E. 7th St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55106,
    "County": "Ramsey",
    "Main phone number": "651-379-4200",
    "Crisis Line Phone Number": "",
    "Organization website": "www.clues.org",
    "Organization Email": "",
    "Hours of operation": "Mon - Thu: 8:30 a.m. - 7:00 p.m. Fri: 8:30 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Spanish on-site; interpreter services for other languages upon request.",
    "Please provide a description of services your organization offers": "Chemical health assessments, therapy and support groups; mental health therapy; domestic violence support groups; sexual assault support service, MNsure navigator assistance and help quitting smoking."
  },
  {
    "Record ID": 23,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "CLUES (Comunidades Latinas Unidas en Servicio)",
    "Address": "720 E. Lake St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55407,
    "County": "Hennepin",
    "Main phone number": "612-746-3500",
    "Crisis Line Phone Number": "",
    "Organization website": "www.clues.org",
    "Organization Email": "",
    "Hours of operation": "Mon - Thu: 8:30 a.m. - 7:00 p.m. Fri: 8:30 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Spanish on-site;  interpreter services for other languages upon request.",
    "Please provide a description of services your organization offers": "Chemical health assessments, therapy and support groups; mental health therapy; domestic violence support groups; sexual assault support service, MNsure navigator assistance and help quitting smoking."
  },
  {
    "Record ID": 24,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Community-University Health Care Center",
    "Address": "2001 Bloomington Ave. S",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55407,
    "County": "Hennepin",
    "Main phone number": "612-638-0700",
    "Crisis Line Phone Number": "",
    "Organization website": "www.ahc.umn.edu/cuhcc/",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 8:00 a.m. – 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Adolescents and adults",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "English, Cambodian, Hmong, Laotian, Somali, Spanish and Vietnamese on-site; Interpreter serivces for other languages upon request.",
    "Please provide a description of services your organization offers": "Various types of therapy, diagnostic assessments, screenings, case management services, advocacy services, rehabilitation and medication management. Services for both adults and adolescents."
  },
  {
    "Record ID": 25,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Dakota County Crisis Response Unit (CRU)",
    "Address": "",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "",
    "State": "",
    "Zip Code": null,
    "County": "Dakota",
    "Main phone number": "",
    "Crisis Line Phone Number": "952-891-7171",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "24 hours, 7 days a week",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Phone and face-to-face crisis intervention and consultation."
  },
  {
    "Record ID": 26,
    "Type of Service": "Disability Services",
    "Name of Organization": "Dakota County Social Services (Western Service Center)",
    "Address": "14955 Galaxie Ave",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Apple Valley",
    "State": "MN",
    "Zip Code": 55124,
    "County": "Dakota",
    "Main phone number": "952-891-7570",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. - 4:30 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Child, adult, family, and developmental disability services, in addition to a wide range of family and child-related services."
  },
  {
    "Record ID": 27,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Gillette Lifetime Clinic",
    "Address": "435 Phalen Blvd.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55130,
    "County": "Ramsey",
    "Main phone number": "651-634-1934",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Developmental disability assessments, clarify guardianship issues; Diagnostic Assessments for anyone with childhood onset physical disabilities."
  },
  {
    "Record ID": 28,
    "Type of Service": "Vision Services",
    "Name of Organization": "Essentia Health",
    "Address": "1027 Washington Avenue",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Detroit Lakes",
    "State": "MN",
    "Zip Code": 56501,
    "County": "Otter Tail",
    "Main phone number": "218-847-5611",
    "Crisis Line Phone Number": "",
    "Organization website": "www.essentiahealth.org",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Comprehensive eye exams, glass and contact lens prescriptions. Medical treatment options for various conditions, including retinal and corneal diseases, glaucoma, low vision, age-related macular degeneration, cataracts, and diabetic retinopathy."
  },
  {
    "Record ID": 29,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Face to Face Health and Counseling Services",
    "Address": "1165 Arcade St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55106,
    "County": "Ramsey",
    "Main phone number": "651-772-5555",
    "Crisis Line Phone Number": "",
    "Organization website": "www.face2face.org",
    "Organization Email": "",
    "Hours of operation": "Walk in counceling: Tue.: 11:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Youth 11-24  years old",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Hmong, Spanish on-site; interpreter services for other languages upon request.",
    "Please provide a description of services your organization offers": "Adolescent/young adult medical care, counseling, mental health case management, services and and programs for homeless youth; and the SafeZone drop-in center with many services and classes. LGBTQ therapy support groups."
  },
  {
    "Record ID": 30,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "First Street Center Carver County Mental Health Program",
    "Address": "540 E. First St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Waconia",
    "State": "MN",
    "Zip Code": 55387,
    "County": "Carver",
    "Main phone number": "952-442-4437",
    "Crisis Line Phone Number": "952-442-7601",
    "Organization website": "www.co.carver.mn.us/departments/health-human-services/first-street-center-mental-health",
    "Organization Email": "",
    "Hours of operation": "Mon. 8:00 a.m. - 4:30 p.m. Tue. 8:00 a.m. - 6:00 p.m. Wed. 7:00 a.m. - 4:30 p.m. Thurs. 8:00 a.m. - 7:30 p.m. Fri. 8:00 a.m. - 2:30 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Carver County residents",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Mental health assessments, therapy and psychiatry to adults (including seniors), adolescents, and children; case management, chemical health, and crisis services."
  },
  {
    "Record ID": 31,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Greater Minneapolis Crisis Nursery",
    "Address": "5400 Glenwood Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Golden Valley",
    "State": "MN",
    "Zip Code": 55422,
    "County": "Hennepin",
    "Main phone number": "763-591-0400",
    "Crisis Line Phone Number": "763-591-0100",
    "Organization website": "www.crisisnursery.org",
    "Organization Email": "",
    "Hours of operation": "24 hours, 7 days a week",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Hennepin County Residents Families with children 0-6 years old. Verification required.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "A voluntary, temporary shelter for children dealing with stress or crisis. 72-hour overnight childcare in a safe environment. Crisis counseling, home visiting, children assessment and medication management, parent education and  support group, and a community roundtable."
  },
  {
    "Record ID": 32,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "HealthPartners / Center for International Health / Behavioral Health Services",
    "Address": "451 N Dunlap St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55104,
    "County": "Ramsey",
    "Main phone number": "952-967-7201",
    "Crisis Line Phone Number": "",
    "Organization website": "www.healthpartners.com",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri . 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Mental health, individual, group and family counseling and medication management. Psychiatrist and psychologist on staff each day. Culturally specific services: Vietnamese Men’s Group; Prison Camp Survivors; Hmong Diabetes Group; Hmong Women’s Support Group."
  },
  {
    "Record ID": 33,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "HealthStar Home Health",
    "Address": "2586 7th Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 302",
    "City": "North St. Paul",
    "State": "MN",
    "Zip Code": 55109,
    "County": "Hennepin",
    "Main phone number": "612-871-3700",
    "Crisis Line Phone Number": "",
    "Organization website": "www.healthstarhomehealth.net/",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 8:00 a.m. – 4:30 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "To qualify for ARMHS Services, must be on or eligible to apply for Medical Assistance.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Somali on-site; interpreter services for other languages upon request.",
    "Please provide a description of services your organization offers": "With Individual Family Solutions (IFS), HealthStar Home Health provides Adult Rehabilitative Mental Health Services (ARMHS) for Somali individuals with mental illness.  Diagnostic assessment and ARMHS with Somali staff."
  },
  {
    "Record ID": 34,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Help Me Grow, Ramsey County Early Childhood Education",
    "Address": "",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "",
    "State": "",
    "Zip Code": null,
    "County": "Ramsey",
    "Main phone number": "651-604-3700",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Ramsey County residents",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Early Intervention intake and referral for children less than 5 years old  (“Healthy Families” for assessments for social security disability insurance (SSDI) (651-266-1568)."
  },
  {
    "Record ID": 35,
    "Type of Service": "Health Services",
    "Name of Organization": "Ramsey County Family Home Visiting",
    "Address": "",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "",
    "State": "",
    "Zip Code": null,
    "County": "Ramsey",
    "Main phone number": "651-266-1568",
    "Crisis Line Phone Number": "",
    "Organization website": "www.ramseycounty.us/residents/health-medical/clinics-services/family-home-visiting",
    "Organization Email": "",
    "Hours of operation": "",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Ramsey County residents “Healthy Families” for assessments for social security disability insurance (SSDI) (651-266-1568).",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Supportive public health and home visiting services for pregnant women and their family to promote the family's wellbeing and address their needs"
  },
  {
    "Record ID": 36,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Hennepin County Outpatient Mental Health Services",
    "Address": "1801 Nicollet Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "2nd and 3rd Floors",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55403,
    "County": "Hennepin",
    "Main phone number": "612-596-9438",
    "Crisis Line Phone Number": "",
    "Organization website": "www.hennepin.us/residents/health-medical/adult-mental-health-services",
    "Organization Email": "",
    "Hours of operation": "Mon., Tues., Thurs., Fri.: 8:00 a.m. to 5:00 p.m. Wed.: 8:00 a.m. - 6:00 p.m",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Services for adults with serious mental illness and/or substance abuse who are currently in crisis or at risk of destabilization. Services for children and adolescents who are severely emotionally disturbed, have been abused or neglected, or have been court ordered for a psychological evaluation.  612-348-2233 (Children)"
  },
  {
    "Record ID": 37,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Hennepin Healthcare Acute Psychiatric Services",
    "Address": "701 Park Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": null,
    "County": "Hennepin",
    "Main phone number": "612-873-3161",
    "Crisis Line Phone Number": "612-843-3161",
    "Organization website": "www.hennepinhealthcare.org/specialty/psychiatry/acute-psychiatry-services/",
    "Organization Email": "",
    "Hours of operation": "24 hours, 7 days a week",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Crisis counseling, assessment, and referral."
  },
  {
    "Record ID": 38,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Hennepin Healthcare Women’s Health and Wellness Program",
    "Address": "715 S. 8th St.",
    "Suite (Ste.) or Apartment (Apt.) number": "Level 5",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": null,
    "County": "Hennepin",
    "Main phone number": "612-873-6963",
    "Crisis Line Phone Number": "",
    "Organization website": "www.hennepinhealthcare.org/specialty/womenshealth/",
    "Organization Email": "",
    "Hours of operation": "Mon.-Fri.: 8:00 a.m. – 4:30 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Care for women's health issues, including pregnancy, family planning, menopause, conditions of the female organs, surgical follow-up. Mental health care by mental health providers specializing in caring for women."
  },
  {
    "Record ID": 39,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Hmong American Partnership",
    "Address": "394 University Ave W",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": null,
    "County": "Ramsey",
    "Main phone number": "651-495-9160",
    "Crisis Line Phone Number": "",
    "Organization website": "www.hmong.org",
    "Organization Email": "",
    "Hours of operation": "Mon.-Fri.: 8:00 a.m. – 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Low-income, uninsured/underinsured Hmong and English- speaking community members.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Hmong on-site",
    "Please provide a description of services your organization offers": "Rule 25 chemical assessments for uninsured youth and adults; culturally aware and sensitive chemical health workshops; counseling; Driving with care workshops; Adult Substance Use Driving Surveys; community forums; and the Hmong Chemical Health Project."
  },
  {
    "Record ID": 40,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "HOPE Center",
    "Address": "1003 7th St. NW",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Faribault",
    "State": "MN",
    "Zip Code": 55021,
    "County": "Rice",
    "Main phone number": "507-332-0882",
    "Crisis Line Phone Number": "1-800-607-2330",
    "Organization website": "www.hopecentermn.org",
    "Organization Email": "",
    "Hours of operation": "Mon-Fri: 9:00-4:00 p.m. ; helpline 24 hours, 7 days a week",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Rice County residents",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Spanish in-person; interpreter services for other languages upon request.",
    "Please provide a description of services your organization offers": "Phone support, emergency shelter, counseling, support groups, hospital support, legal advocacy."
  },
  {
    "Record ID": 41,
    "Type of Service": "Health Services",
    "Name of Organization": "JustUs Health",
    "Address": "",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "",
    "State": "",
    "Zip Code": null,
    "County": "Statewide",
    "Main phone number": "612-373-2437",
    "Crisis Line Phone Number": "",
    "Organization website": "www.justushealth.org/get-support/health-wellness/connecting-care",
    "Organization Email": "",
    "Hours of operation": "Mon. – Fri.: 9 a.m. to 5 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Navigation of HIV services, including behavioral health, connection to care and case management, benefits and insurance, legal, especially for LGBTQI at risk or living with HIV."
  },
  {
    "Record ID": 42,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "JustUs Health Behavioral Health",
    "Address": "1000 University Ave. W",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 20",
    "City": "Saint Paul",
    "State": "MN",
    "Zip Code": 55104,
    "County": "Ramsey",
    "Main phone number": "612-373-9160",
    "Crisis Line Phone Number": "",
    "Organization website": "www.justushealth.org/clinic",
    "Organization Email": "",
    "Hours of operation": "Mon, Tues, Thurs: 9 a.m. to 6 p.m.  Wed: 9 a.m. to 8 p.m.  Fri:  9 a.m. to 5 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Mental, chemical, and sexual health services for LGBTIA+ people, people living with HIV, and  community members who historically and currently face barriers to behavioral health support. Individual, group, couple, and family therapy. "
  },
  {
    "Record ID": 43,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "M Health Fairview Ridges Providers Diagnostic Evaluation Center (DEC)",
    "Address": "201 Nicollet Blvd.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Burnsville",
    "State": "MN",
    "Zip Code": 55337,
    "County": "Dakota",
    "Main phone number": "952-892-2913",
    "Crisis Line Phone Number": "",
    "Organization website": "www.bhpcare.com",
    "Organization Email": "",
    "Hours of operation": "Sun. - Mon. 9:00 a.m. - 1:00 a.m. Tues. - Fri. 5:00 p.m. - 1:00 a.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Crisis mental health assessments."
  },
  {
    "Record ID": 44,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "M Health Fairview Behavioral Emergency Center (BEC) and Intake",
    "Address": "2312 S. 6th St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55454,
    "County": "Hennepin",
    "Main phone number": "612-672-6600",
    "Crisis Line Phone Number": "612-273-5640",
    "Organization website": "www.mhealth.org/childrens/care/overarching-care/behavioral-health-and-mental-health-pediatrics",
    "Organization Email": "",
    "Hours of operation": "24 hours, 7 daya a week",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Any person (any age) needing behavioral emergency care seen 24/7 at the M Health Fairview’s West Bank Emergency Department. Services include assessment and referral for anyone having a mental health or substance abuse crisis."
  },
  {
    "Record ID": 45,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "M Health Fairview Counseling Centers",
    "Address": "2450 Riverside Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55454,
    "County": "Hennepin",
    "Main phone number": "612-672-6999",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.fairview.org/services/counseling-centers",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 8:00 a.m. – 4:30 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Short-term, holistic therapy to address mental and behavioral health needs using strength-based approaches, diet, sleep and exercise guidance, in collaboration with primary care providers"
  },
  {
    "Record ID": 46,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "M Health Fairview clinic - Smiley's",
    "Address": "2020 E 28th St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55407,
    "County": "Hennepin",
    "Main phone number": "(612) 333-0770",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.mhealth.org/care/services/behavioral-health-home#related-locations",
    "Organization Email": "",
    "Hours of operation": "24 hours, 7 days a week",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Diagnozed with serious and persistane mental illness and disturbances",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Public insurance (MA, MNCare)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Behavioral health home providing comprehensive medical and behavioral health services, comprehensive care management and coordination, individual and family support, health and wellness promotion. No out-of pocket cost of eligible patients."
  },
  {
    "Record ID": 47,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "M Health Fairview Neurology Clinic, Phillips- Wangensteen Bldg.",
    "Address": "516 Delaware St. SE",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55455,
    "County": "Hennepin",
    "Main phone number": "612-626-6688",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Neuropsychological Evaluation."
  },
  {
    "Record ID": 48,
    "Type of Service": "Vision Services",
    "Name of Organization": "Mankato Clinic- Eye Care Center",
    "Address": "1421 Premier Drive",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Mankato",
    "State": "MN",
    "Zip Code": 56001,
    "County": "Blue Earth",
    "Main phone number": "507-385-4070",
    "Crisis Line Phone Number": "",
    "Organization website": "www.mankatoclinic.com",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 8:00 a.m - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Full spectrum of care including routine eye exams, diagnosis and medical treatment of eye disorders and diseases, prescriptions for eyeglasses, surgery, and management of eye problems caused by systemic illnesses."
  },
  {
    "Record ID": 49,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Mental Health Minnesota Crisis Help Finder",
    "Address": "",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "",
    "State": "",
    "Zip Code": null,
    "County": "Statewide",
    "Main phone number": "651-493-6634",
    "Crisis Line Phone Number": "1-800-862-1799",
    "Organization website": "mentalhealthmn.org/support/crisis/",
    "Organization Email": "",
    "Hours of operation": "",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Find a local mental health crisis support using the search tool, searchable by zip code or county in Minnesota."
  },
  {
    "Record ID": 50,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Mercy Hospital Mental Health and Addiction Services",
    "Address": "4050 Coon Rapids Blvd.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Coon Rapids",
    "State": "MN",
    "Zip Code": 55433,
    "County": "Anoka",
    "Main phone number": "763-236-7911",
    "Crisis Line Phone Number": "1-866-603-0016",
    "Organization website": "account.allinahealth.org/servicelines/826",
    "Organization Email": "",
    "Hours of operation": "24 hours, 7 days a week",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Mental health assessment and referral through the emergency room, assessment for admission to a mental health unit."
  },
  {
    "Record ID": 51,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Metro Behavioral Health",
    "Address": "2700 E Lake Street",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 2100",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55406,
    "County": "Hennepin",
    "Main phone number": "612-767-7770",
    "Crisis Line Phone Number": "",
    "Organization website": "www.metrobhealth.com",
    "Organization Email": "mohamed@metrobhealth.com",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. -6:00 p.m. Evening hours by special appointments. Telephone hours 9:00 a.m.-5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "English and Somali",
    "Please provide a description of services your organization offers": "Behaviorial health services to patients with diverse cultural backgrounds, tailored to individual/family capacity and current life context using holistic and strengths-based approaches."
  },
  {
    "Record ID": 52,
    "Type of Service": "Health Services",
    "Name of Organization": "Minneapolis Clinic of Neurology",
    "Address": "4225 Golden Valley Rd.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Golden Valley",
    "State": "MN",
    "Zip Code": 55422,
    "County": "Hennepin",
    "Main phone number": "763-302-4102",
    "Crisis Line Phone Number": "",
    "Organization website": "minneapolisclinic.com",
    "Organization Email": "",
    "Hours of operation": "",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Neuropsychological evaluations"
  },
  {
    "Record ID": 53,
    "Type of Service": "Vision Services",
    "Name of Organization": "M Health Fairview Minnesota Lions Children's Eye Clinic Park Plaza Building",
    "Address": "701 25th Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55454,
    "County": "Hennepin",
    "Main phone number": "612-365-8350",
    "Crisis Line Phone Number": "",
    "Organization website": "www.mhealth.org/childrens/locations/buildings/park-plaza-building#clinics-and-services",
    "Organization Email": "",
    "Hours of operation": "Mon.- Fri.: 8 a.m. to 4:30 p.m",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Vision care for common and rare conditions affecting children."
  },
  {
    "Record ID": 54,
    "Type of Service": "Vision Services",
    "Name of Organization": "Minnesota State Services for the Blind Department of Employment and Economic Development",
    "Address": "2200 University Ave. W",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 240",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55114,
    "County": "Ramsey",
    "Main phone number": "651-539-2300",
    "Crisis Line Phone Number": "",
    "Organization website": "https://mn.gov/deed/ssb/",
    "Organization Email": "",
    "Hours of operation": "",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "In general, to be eligible, corrected vision in your best eye needs to be 20 over 60 or higher. Corrected vision simply means what you can or can’t see while wearing glasses or lenses. Other eligibility criteria on the website.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "In most cases, there is no cost to our consumers for our services. In those instances where we may ask consumers to share costs, we will let you know up front, so that you can make your decisions.",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Employment services for the blind and vision-impaired persons (over 14 years old); services for seniors or persons with disabilities to keep them active and independent. Some equipments, in-home and community-based assessment and training."
  },
  {
    "Record ID": 55,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Model Cities: Family Support Services",
    "Address": "839 University Ave. W",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55104,
    "County": "Ramsey",
    "Main phone number": "651-632-8342",
    "Crisis Line Phone Number": "",
    "Organization website": "www.modelcities.org/model-cities-st-paul/family-support-services/",
    "Organization Email": "",
    "Hours of operation": "Call for hours",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Comprehensive home-based services for children, individuals and families with the goal of achieving family reunification and individual stabilization. Intensive case management and crisis intervention services to work towards greater independence"
  },
  {
    "Record ID": 56,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Multi-Cultural Care, LLC (Mary Conner, MA, LP)",
    "Address": "1929 5th St. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "#103",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55454,
    "County": "Hennepin",
    "Main phone number": "(612) 584-3138",
    "Crisis Line Phone Number": "",
    "Organization website": "www.multi-culturalcare.com/",
    "Organization Email": "Maryc@multi-culturalcare.com",
    "Hours of operation": "Call in for Clinic hours",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare)",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Assessments and psychotherapy, assessments for N-648 medical waivers and evaluations for asylum seekers, disability andAdult Rehabilitative Mental Health Services (ARMHS)"
  },
  {
    "Record ID": 57,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Natalis Counseling & Psychology Solutions",
    "Address": "1600 University Ave W.",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 12",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55104,
    "County": "Ramsey",
    "Main phone number": "651-379-5157",
    "Crisis Line Phone Number": "",
    "Organization website": "www.natalispsychology.com",
    "Organization Email": "",
    "Hours of operation": "Mon. – Fri.: 9:00 a.m. – 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Individual counseling with providers adept in working across cultures and committed to working with newly arriving refugees. Several providers  with various approaches. Psychiatrist on site to refer for prescription management."
  },
  {
    "Record ID": 58,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "National Domestic Violence Hotline",
    "Address": "",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "",
    "State": "",
    "Zip Code": null,
    "County": "Statewide",
    "Main phone number": "",
    "Crisis Line Phone Number": "1-800-799-7233",
    "Organization website": "www.thehotline.org",
    "Organization Email": "",
    "Hours of operation": "24 hours, 7 days a week",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Crisis intervention, safety planning, resources."
  },
  {
    "Record ID": 59,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "National Suicide Prevention lifeline",
    "Address": "",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "",
    "State": "",
    "Zip Code": null,
    "County": "Statewide",
    "Main phone number": "",
    "Crisis Line Phone Number": "1-800-273-8255;   1-888-628-9454 (Spanish)",
    "Organization website": "suicidepreventionlifeline.org",
    "Organization Email": "",
    "Hours of operation": "24 hours, 7 days a week",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Spanish language line; other languages through telephone interpreter services",
    "Please provide a description of services your organization offers": "Provides confidential support for people in distress, prevention and crisis resources, and best practices for professionals."
  },
  {
    "Record ID": 60,
    "Type of Service": "Vision Services",
    "Name of Organization": "NorthPoint Health and Wellness Center",
    "Address": "1313 Penn Avenue North",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55411,
    "County": "Hennepin",
    "Main phone number": "612-543-2500",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.northpointhealth.org/optometry",
    "Organization Email": "",
    "Hours of operation": "Monday & Friday: 8:00 a.m. - 5:00 p.m. / Tuesday-Thursday: 8:00 a.m-7:00 p.m. / Saturday by appointment only",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Eye exams (excluding contact lens exams), eyeglass prescriptions, and treatment for health concerns such as glaucoma, conjunctivitis and pink eye."
  },
  {
    "Record ID": 61,
    "Type of Service": "Vision Services",
    "Name of Organization": "Open Cities Health Center",
    "Address": "409 North Dunlap Street",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55104,
    "County": "Ramsey",
    "Main phone number": "651-290-9200",
    "Crisis Line Phone Number": "",
    "Organization website": "www.ochealthcenter.com",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Comprehensive eye exams screen for many vision conditions: blurry vision, pain, allergies, itching, floaters, dryness, gritty/sandy feeling, flashes of light, eye strain, watering, difficulty seeing at night, or glare/halos."
  },
  {
    "Record ID": 62,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Pathways Counseling Center Inc.",
    "Address": "1919 University Ave W",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 6",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55104,
    "County": "Ramsey",
    "Main phone number": "651-641-1555",
    "Crisis Line Phone Number": "",
    "Organization website": "www.pathwayscounselingcenter.org",
    "Organization Email": "",
    "Hours of operation": "Mon. – Fri.: 9:00 a.m. – 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Pathways understands the importance of utilizing culturally-appropriate methods when engaging with refugees, honoring cultural systems and values to foster recovery and resilience processes."
  },
  {
    "Record ID": 63,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "People Incorporated",
    "Address": "317 York Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55130,
    "County": "Ramsey",
    "Main phone number": "612-872-2000",
    "Crisis Line Phone Number": "",
    "Organization website": "www.peopleincorporated.org",
    "Organization Email": "",
    "Hours of operation": "Monday - Friday: 7:00am-5:30pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services upon request.",
    "Please provide a description of services your organization offers": "Individual and family counseling, early childhood mental health, school-linked counseling, day treatment for children, domestic abuse prevention, anger management, and parent support services. Assessments, psychiatric medication management, psychotherapy, group therapy, family therapy and couples counseling. Crisis residences for  men and women in Saint Paul and Minneapolis. Other locations in Coon Rapids and Mendota Heights."
  },
  {
    "Record ID": 64,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "People's Center Clinics & Services",
    "Address": "425 20th Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55454,
    "County": "Hennepin",
    "Main phone number": "612-332-4973",
    "Crisis Line Phone Number": "",
    "Organization website": "www.peoples-center.org/behavioral-health",
    "Organization Email": "",
    "Hours of operation": "Mon. and Fri: 8:30 a.m. – 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Somali, Oromo, Amharic, Hmong, Korean, Arabic, Spanish, French - all by appointment.",
    "Please provide a description of services your organization offers": "Assessments, individual and family therapy, and referrals. Diabetes education group for speakers."
  },
  {
    "Record ID": 65,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Progressive Individual Resources, Inc.",
    "Address": "7710 Brooklyn Blvd",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 209",
    "City": "Brooklyn Park",
    "State": "MN",
    "Zip Code": 22443,
    "County": "Hennepin",
    "Main phone number": "651-269-2760",
    "Crisis Line Phone Number": "",
    "Organization website": "www.pirimn.org",
    "Organization Email": "",
    "Hours of operation": "Mon. – Fri.: 9:00 a.m. – 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "18 and older",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare)",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Services for families, caregivers to children, youth and adults with severe emotional disturbances (SED), behavioral challenges and developmental disabilities. In-home family support for children with SED, rehabilitative services through Children Therapeutic Services of Supports, respite services for SED children/ youth, short-term transition living arrangements for juvenile delinquent youth, ARMHS. Intellectual and/or developmental disability (IDD)."
  },
  {
    "Record ID": 66,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Riverwind Crisis Residence",
    "Address": "2708 119th Avenue NW",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Coon Rapids",
    "State": "MN",
    "Zip Code": 55433,
    "County": "Anoka",
    "Main phone number": "763-862-7944",
    "Crisis Line Phone Number": "763-862-7944",
    "Organization website": "www.peopleincorporated.org",
    "Organization Email": "",
    "Hours of operation": "24 hours, 7 days a week",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants for Anoka county)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Short-term mental health crisis stabilization services for adults with mental illness who also may be experiencing significant life stressors or substance use issues. Average stay is 3-5 days. Length of services is dependent on progress towards care goals. Riverwind provides supportive counseling and group counseling (IMR, IDDT) centered around developing a crisis response action plan."
  },
  {
    "Record ID": 67,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Scott County Mental Health Center",
    "Address": "200 Fourth Ave. W.",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 300",
    "City": "Shakopee",
    "State": "MN",
    "Zip Code": 55379,
    "County": "Scott",
    "Main phone number": "952-496-8481",
    "Crisis Line Phone Number": "952-818-3702",
    "Organization website": "www.co.scott.mn.us",
    "Organization Email": "",
    "Hours of operation": "Mon. - Thurs. 8:00 a.m. - 4:30 p.m. crisis line available 4:30 pm- 8:00 am",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants for Scott county)",
    "Interpretation services": "Spanish, Russian, Hmong, and Somali",
    "Please provide a description of services your organization offers": "Individual and family therapy, psychological evaluations, anger management, day treatment, diagnostic assessment, couple’s counseling, life skills, women’s group, Dialectic Behavior Therapy (DBT) group."
  },
  {
    "Record ID": 68,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "South East Homes",
    "Address": "2732 Bloomington Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55407,
    "County": "Hennepin",
    "Main phone number": "612-722-5411",
    "Crisis Line Phone Number": "",
    "Organization website": "southeasthomes.org",
    "Organization Email": "admin@southeasthomes.org",
    "Hours of operation": "Mon- Fri: 9:00  a.m.- 6:00 pm; Sat: 10: 00 am - 4:00 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "East African males ages 16 and up.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Private, Public, Sliding Scale, Self-pay, federal/state funding",
    "Interpretation services": "Somali",
    "Please provide a description of services your organization offers": "Mental health/chemical dependency residential and outpatient clinical services. Somali American Recovery Support Groups via conference line."
  },
  {
    "Record ID": 69,
    "Type of Service": "Vision Services",
    "Name of Organization": "Southside Community Health Services",
    "Address": "4243 4th Ave. S",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55409,
    "County": "Hennepin",
    "Main phone number": "612-821-2003",
    "Crisis Line Phone Number": "",
    "Organization website": "www.southsidechs.org/vision",
    "Organization Email": "",
    "Hours of operation": "Mon. & Wed. 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Spanish, Hmong, Lao, Japanese, Korean, French, and Farsi. Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Eye exams, depth perception, color perception, muscle balance, eye coordination, diagnosis and treatment of eye disease, diabetic eye exams, urgent eye care (pink eye and allergies), eye glasses and contacts"
  },
  {
    "Record ID": 70,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "St. David’s Center Autism Day Treatment (The Harman Center for Child and Family Wellbeing)",
    "Address": "1200 Marquette Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55403,
    "County": "Hennepin",
    "Main phone number": "(952) 548-8700",
    "Crisis Line Phone Number": "",
    "Organization website": "www.stdavidscenter.org",
    "Organization Email": "",
    "Hours of operation": "Mon-Fri: 8:30 am -  8:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "2 to 6 years old",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Somali onsite; Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Early Intervention treatment services for Somali children 2-6 years old with autism spectrum disorder (ASD). Somali-speaking staff assist with intake, assessment and intervention treatments.  Weekly home visits."
  },
  {
    "Record ID": 71,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Summit Guidance Center (Ahmed Hassan)",
    "Address": "1821 University Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "N-180",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55104,
    "County": "Ramsey",
    "Main phone number": "651-348-8073",
    "Crisis Line Phone Number": "",
    "Organization website": "summit-guidance.com/",
    "Organization Email": "ahmedhassan01@yahoo.com summitguidance@gmail.com",
    "Hours of operation": "Mon. - Fri.: 8:00 a.m. – 7:00 p.m. Sat.: 9:00 a.m. – 3:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Outpatient and in-home mental health services, including diagnostic assessment, individual therapy, family consultation, and case coordination."
  },
  {
    "Record ID": 72,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "The MPSI Psychotherapy Center",
    "Address": "3108 Hennepin Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55408,
    "County": "Hennepin",
    "Main phone number": "612-824-3800",
    "Crisis Line Phone Number": "",
    "Organization website": "www.mpsi-pc.org",
    "Organization Email": "",
    "Hours of operation": "Call to make an appointment",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "• Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Therapy that values a strong patient relationship with the therapist to understand the person's sources of emotional distress and promote personal development."
  },
  {
    "Record ID": 73,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Todd Sigler, PsyD, NCC Outreach Counseling Service",
    "Address": "Winsor Office Plaza 2 West",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 270",
    "City": "Roseville",
    "State": "MN",
    "Zip Code": 55113,
    "County": "Ramsey",
    "Main phone number": "651-481-0664",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "todds@outreachcounseling.com",
    "Hours of operation": "",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Diagnostic assessments for refugee clients required for county disability services (LTC waivered service assessment, and other county disability services)."
  },
  {
    "Record ID": 74,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "True Thao Counseling Services",
    "Address": "796 E. 7th Street",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55106,
    "County": "Ramsey",
    "Main phone number": "651-771-2155",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "Call in for Clinic hours",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Trauma-informed and evidence-based treatment modalities; individual, couples, and family counseling; understanding of new refugees’ lives and the issues affecting them. Services provided by therapists in Hmong, Nepali, Hindi, and Tibetan."
  },
  {
    "Record ID": 75,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Urgent Care for Adult Mental Health",
    "Address": "402 University Ave. E.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55130,
    "County": "Ramsey",
    "Main phone number": "651-266-7900",
    "Crisis Line Phone Number": "651-266-7900",
    "Organization website": "https://www.ramseycounty.us/residents/health-medical/clinics-services/mental-behavorial-health/adult-mental-health-chemical-health/urgent-care-adult-mental-health",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. - 5:30 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Any adult age 18 or over",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Mental health crisis assessments, access to crisis psychiatry, chemical health screening, peer support, crisis stabilization services, family education and support, crisis phone support, referral to community resources in Ramsey, Dakota and Washington Counties."
  },
  {
    "Record ID": 76,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Minnesota Prevention Resource Center",
    "Address": "2395 University Ave. W.",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 310",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55114,
    "County": "Statewide",
    "Main phone number": "651-646-3005",
    "Crisis Line Phone Number": "",
    "Organization website": "mnprc.org/",
    "Organization Email": "",
    "Hours of operation": "",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Support services for people and organizations to engage in addressing the causes of substance abuse. Trainings on prevention skills and a provider of prevention resources."
  },
  {
    "Record ID": 77,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Volunteers of America - Mental Health Clinic",
    "Address": "9220 Bass Rd",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 255",
    "City": "New Hope",
    "State": "MN",
    "Zip Code": 55428,
    "County": "Hennepin",
    "Main phone number": "763-225-4052",
    "Crisis Line Phone Number": "",
    "Organization website": "www.voamnwi.org/mental-health-services",
    "Organization Email": "",
    "Hours of operation": "Mon. - Thur.: 8:30 a.m. – 5:30 p.m.  Fri: 8:30 am -1:30 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Somali on-site; Interpreter services for other East African languages available upon request.",
    "Please provide a description of services your organization offers": "Somali and  East African Behavioral Health Services Programs."
  },
  {
    "Record ID": 78,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Walk-in Counseling Center",
    "Address": "2421 Chicago Ave. S",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55404,
    "County": "Hennepin",
    "Main phone number": "612-870-0565",
    "Crisis Line Phone Number": "",
    "Organization website": "www.walkin.org",
    "Organization Email": "",
    "Hours of operation": "Mon., Wed., Fri.: 1:00 p.m. – 3:00pm. Mon. -Thur.: 6:30 p.m. - 8:30 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Mental health counseling. No appointment needed."
  },
  {
    "Record ID": 79,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Walk-in Counseling Center at Family Tree",
    "Address": "1619 Dayton Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55104,
    "County": "Ramsey",
    "Main phone number": "612-870-0565",
    "Crisis Line Phone Number": "",
    "Organization website": "www.walkin.org",
    "Organization Email": "",
    "Hours of operation": "Mon., Wed.: 5:00 p.m. - 7:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Mental health counseling. No appointment needed."
  },
  {
    "Record ID": 80,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Walk-in Counseling Center at Neighborhood House",
    "Address": "179 Robie St. E",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55107,
    "County": "Ramsey",
    "Main phone number": "612-870-0565",
    "Crisis Line Phone Number": "",
    "Organization website": "www.walkin.org",
    "Organization Email": "",
    "Hours of operation": "Tues: 6:00 pm - 8:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Mental health counseling. No appointment needed."
  },
  {
    "Record ID": 81,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Washburn Center for Children",
    "Address": "1100 Glenvood Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55405,
    "County": "Hennepin",
    "Main phone number": "612-871-1454",
    "Crisis Line Phone Number": "",
    "Organization website": "washburn.org/",
    "Organization Email": "",
    "Hours of operation": "24 hours, 7 days a week",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Focus on children’s mental health and helps those with social, emotional and behavioral problems. Services in 22 public schools in Minneapolis and through home visits"
  },
  {
    "Record ID": 82,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Watercourse Counseling",
    "Address": "3548 Bryant Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55408,
    "County": "Hennepin",
    "Main phone number": "612-822-8227",
    "Crisis Line Phone Number": "",
    "Organization website": "www.watercoursecounseling.org",
    "Organization Email": "",
    "Hours of operation": "Mon. - Thurs.: 8:00 a.m. - 5:00 p.m. Fri.: 9:00 a.m. - 12:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Somali, Spanish, Oromo, Amharic on site;interpreter services for other languages upon request.",
    "Please provide a description of services your organization offers": "Individual, family, couples, and group counseling for adults and children."
  },
  {
    "Record ID": 83,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Wilder Foundation Mental & Chemical Health Services",
    "Address": "451 Lexington Parkway N.",
    "Suite (Ste.) or Apartment (Apt.) number": "2nd Floor",
    "City": "St, Paul",
    "State": "MN",
    "Zip Code": 55104,
    "County": "Ramsey",
    "Main phone number": "651-280-2310",
    "Crisis Line Phone Number": "",
    "Organization website": "www.wilder.org/what-we-offer/mental-chemical-health-services",
    "Organization Email": "",
    "Hours of operation": "Mon. - Thur. 8:00 a.m. - 7:00 p.m.  Fri: 8:00 a.m. - 4:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Hmong, Karen, Khmer, Vietnamese on-site; interpreter services for other languages upon request.",
    "Please provide a description of services your organization offers": "Services for social, emotional, behavioral, mental and chemical health concerns. Trauma-informed and culturally appropriate approach. Appointment at clinic, home, school, in the community or by phone."
  },
  {
    "Record ID": 84,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Woodland Centers Kandiyohi Center",
    "Address": "1125 6th St. SE",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Willmar",
    "State": "MN",
    "Zip Code": 56201,
    "County": "Kandiyohi",
    "Main phone number": "320-235-4613",
    "Crisis Line Phone Number": "",
    "Organization website": "www.woodlandcenters.com",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Comprehensive mental health services. Counseling support for families, psychiatric assessment, medication management, treatment for addictions, programs for sex offenders."
  },
  {
    "Record ID": 85,
    "Type of Service": "Health Services",
    "Name of Organization": "NorthPoint Health & Wellness Center",
    "Address": "1313 Penn Ave. N.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55411,
    "County": "Hennepin",
    "Main phone number": "612-543-2500",
    "Crisis Line Phone Number": "",
    "Organization website": "www.northpointhealth.org",
    "Organization Email": "",
    "Hours of operation": "Mon. & Fri. 8:00 a.m. - 5:00 p.m. Tues - Thurs. 8:00 a.m. - 7:00 p.m. Sat. 8:00 a.m. - 12:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "primary care, internal medicine, pediatrics, OB/GYN, adolescent medicine, diabetes care, pharmacy, reproductive health, nutrition, Chemical dependency and harm reduction."
  },
  {
    "Record ID": 86,
    "Type of Service": "Disability Services",
    "Name of Organization": "PACER Center: Health Information Center",
    "Address": "8161 Normandale Blvd.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55437,
    "County": "Hennepin",
    "Main phone number": "952-838-9000",
    "Crisis Line Phone Number": "",
    "Organization website": "www.pacer.org",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Families of children, ages 0-22, with disabilities or special health care needs.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Most services free of charge",
    "Interpretation services": "Spanish, Hmong, Somali in-house with translated materials; ask for other languages.",
    "Please provide a description of services your organization offers": "Information on insurance, government programs, suplemental security income, health resources and advocacy, special education resources and advocacy, referrals to services.Workshops available."
  },
  {
    "Record ID": 87,
    "Type of Service": "Health Services",
    "Name of Organization": "Partners in Pediatrics",
    "Address": "3910 Excelsior Blvd",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Louis Park",
    "State": "MN",
    "Zip Code": 55416,
    "County": "Hennepin",
    "Main phone number": "952-562-8787",
    "Crisis Line Phone Number": "",
    "Organization website": "www.pipstop.com",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Birth to 23.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, public insurance",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Preventative care, injury, mental health, pediatric care . Walk-in service for simple illness or simple injury only."
  },
  {
    "Record ID": 88,
    "Type of Service": "Health Services",
    "Name of Organization": "Planned Parenthood of North Central States",
    "Address": "918 W. Lake St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55408,
    "County": "Hennepin",
    "Main phone number": "612-823-6300",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.plannedparenthood.org/planned-parenthood-north-central-states",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 10:00 a.m. - 8:00 p.m.; Sat. & Sun: 10:00 a.m. - 6:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Walk-in services include: HIV testing, emergency contraception, and pregnancy testing. Services Interpreter services available upon request : family planning, reproductive health care for men and women, STI testing, treatment, and vaccines, LGBTQ services."
  },
  {
    "Record ID": 89,
    "Type of Service": "Health Services",
    "Name of Organization": "Planned Parenthood of North Central States",
    "Address": "6900 78th Ave N.",
    "Suite (Ste.) or Apartment (Apt.) number": "#103",
    "City": "Brooklyn Park",
    "State": "MN",
    "Zip Code": 55445,
    "County": "Hennepin",
    "Main phone number": "763-560-3050",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.plannedparenthood.org/planned-parenthood-north-central-states",
    "Organization Email": "",
    "Hours of operation": "Mon., Wed.,  Fri.: 9:30 a.m. - 5:00pm. Tues. & Thur.: 10:30 a.m. - 6:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Walk-in services include: HIV testing, emergency contraception, and pregnancy testing. Services Interpreter services available upon request : family planning, reproductive health care for men and women, STI testing, treatment, and vaccines, LGBTQ services."
  },
  {
    "Record ID": 90,
    "Type of Service": "Health Services",
    "Name of Organization": "Planned Parenthood of North Central States",
    "Address": "582 Prairie Center Drive",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 215",
    "City": "Eden Prairie",
    "State": "MN",
    "Zip Code": 55344,
    "County": "Hennepin",
    "Main phone number": "952-653-4499",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.plannedparenthood.org/planned-parenthood-north-central-states",
    "Organization Email": "",
    "Hours of operation": "Mon., Wed., Fri.: 10:00 a.m. -4:00pm. Tues. & Thurs.: 12:00 p.m. -6:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Walk-in services include: HIV testing, emergency contraception, and pregnancy testing. Services Interpreter services available upon request : family planning, reproductive health care for men and women, STI testing, treatment, and vaccines, LGBTQ services."
  },
  {
    "Record ID": 91,
    "Type of Service": "Health Services",
    "Name of Organization": "Planned Parenthood of North Central States",
    "Address": "6527 Lyndale Ave So.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Richfield",
    "State": "MN",
    "Zip Code": 55423,
    "County": "Hennepin",
    "Main phone number": "612-874-1420",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.plannedparenthood.org/planned-parenthood-north-central-states",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 9:30 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Walk-in services include: HIV testing, emergency contraception, and pregnancy testing. Services Interpreter services available upon request : family planning, reproductive health care for men and women, STI testing, treatment, and vaccines, LGBTQ services."
  },
  {
    "Record ID": 92,
    "Type of Service": "Health Services",
    "Name of Organization": "Sheridan Clinic",
    "Address": "342 13th Ave. NE",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55413,
    "County": "Hennepin",
    "Main phone number": "612-588-9411",
    "Crisis Line Phone Number": "",
    "Organization website": "www.neighborhoodhealthsource.org",
    "Organization Email": "",
    "Hours of operation": "Mon. 8:00 a.m. - 8:00 p.m. Tues. - Fri. 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Family practice; family planning, pregnancy and STI testing; prenatal and postpartum care; nutrition counseling; mental health services; health education and promotion.  I-694 immigration medical exams"
  },
  {
    "Record ID": 93,
    "Type of Service": "Health Services",
    "Name of Organization": "Shriners Hospitals for Children",
    "Address": "2025 East River Parkway",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55414,
    "County": "Hennepin",
    "Main phone number": "612-596-6100",
    "Crisis Line Phone Number": "",
    "Organization website": "www.shrinershospitalsforchildren.org",
    "Organization Email": "",
    "Hours of operation": "Clinic: Mon. - Fri. 8:00 a.m. - 4:00 p.m. Surgery: Mon. - Thurs.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Ages 0-18 with treatable orthopaedic conditions.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Surgery center and specialty clinic for foot, hand, hip, limb deficiency, spine, plastic surgery, and rheumatology care. Onsite orthotists, prosthetists,  therapists, pediatric orthopaedic surgeons"
  },
  {
    "Record ID": 94,
    "Type of Service": "Health Services",
    "Name of Organization": "M Health-Fairview Clinic - Smiley's",
    "Address": "2020 28th St. E.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55407,
    "County": "Hennepin",
    "Main phone number": "612-333-0770",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.mhealth.org/locations/buildings/university-of-minnesota-physicians-smileys-family-medicine-clinic",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Primarey care, mental health, pregnancy and childbirth, vaccinations, geriatrics, care management.  Pharmacy."
  },
  {
    "Record ID": 95,
    "Type of Service": "Health Services",
    "Name of Organization": "University of MN Amplatz Children’s Hospital: Journey Clinic Center for Children with Cancer and Blood Diseases",
    "Address": "2450 Riverside Ave. , Floor 9",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55454,
    "County": "Hennepin",
    "Main phone number": "612-365-8100",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.mhealth.org/childrens/locations/buildings/east-building/pediatric-specialty-care-journey-clinic",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri., 8 am - 5 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Specialty care for children with cancers or blood diseases.  Primary care not needed prior to referral. Call placement center to determine clinic/specialty client should go to."
  },
  {
    "Record ID": 96,
    "Type of Service": "Health Services",
    "Name of Organization": "Allina Clinic-New Ulm Medical Center",
    "Address": "1324 Fifth Street North",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "New Ulm",
    "State": "MN",
    "Zip Code": 56073,
    "County": "Kandiyohi",
    "Main phone number": "507-217-5011",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.allinahealth.org/new-ulm-medical-center",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 8:00am - 5:00pm.  Walk-in clinic (urgent care, ages 2 mos and older):  Mon. - Fri.: 8 am - 7 pm, Sat and Sun: 8 am - 3 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Primary care, walk-in care, women's health, birth center, cancer care, palliative care, rehabilitation services, surgical care."
  },
  {
    "Record ID": 97,
    "Type of Service": "Health Services",
    "Name of Organization": "Family Practice Medical Center Lakeland Health Center",
    "Address": "502 Second St. SW",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 1",
    "City": "Willmar",
    "State": "MN",
    "Zip Code": 56201,
    "County": "Kandiyohi",
    "Main phone number": "320-235-7232",
    "Crisis Line Phone Number": "",
    "Organization website": "https://fpmc-willmar.com/",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 8:30 a.m. - 5:00 p.m. Urgent Care: Sat. : 9:00 a.m. - 12:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Primary care, ob/gyn, Lab"
  },
  {
    "Record ID": 98,
    "Type of Service": "Health Services",
    "Name of Organization": "Kandiyohi County Health and Human Services",
    "Address": "2200 23rd St. NE",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 1020",
    "City": "Willmar",
    "State": "MN",
    "Zip Code": 56201,
    "County": "Kandiyohi",
    "Main phone number": "320-231-7800",
    "Crisis Line Phone Number": "",
    "Organization website": "www.co.kandiyohi.mn.us",
    "Organization Email": "",
    "Hours of operation": "Mon. – Fri.: 8:00 a.m. – 4:30 p.m. Immunization Clinics on some Mondays (call for details): 2:00p.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Spanish and Somali on-site; interpreter services for other languages upon request.",
    "Please provide a description of services your organization offers": "Immunization, child/teen check-up outreach, family home visiting, Women, Infants, Children (WIC), tuberculosis case management, PCA screening, Follow Along program, Perinatal Hepatitis B case management. Immunizations and TB screening for change of status."
  },
  {
    "Record ID": 99,
    "Type of Service": "Health Services",
    "Name of Organization": "Planned Parenthood of North Central States",
    "Address": "2320 E. Highway 12",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 6",
    "City": "Willmar",
    "State": "MN",
    "Zip Code": 56201,
    "County": "Kandiyohi",
    "Main phone number": "320-235-9150",
    "Crisis Line Phone Number": "",
    "Organization website": "www.ppmns.org",
    "Organization Email": "",
    "Hours of operation": "Mon. :10:00 a.m. - 5:00 p.m.; Tues.: 9:00 a.m. - 3:00 p.m.; Thurs: 9 am - 4 pm; Closed on Wed, Fri-Sun",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Walk-in services include: HIV testing, emergency contraception, pregnancy testing. Services Interpreter services available upon request : reproductive health care (men and women), STI testing treatment and vaccines, family planning."
  },
  {
    "Record ID": 100,
    "Type of Service": "Health Services",
    "Name of Organization": "Good Samaritan Medical Clinic",
    "Address": "120 N. Broadway",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. B",
    "City": "Rochester",
    "State": "MN",
    "Zip Code": 55906,
    "County": "Olmsted",
    "Main phone number": "507-529-4100",
    "Crisis Line Phone Number": "",
    "Organization website": "https://centralusa.salvationarmy.org/northern/GoodSamaritanclinic",
    "Organization Email": "",
    "Hours of operation": "Clinic hours vary throughout the month.  Monthly schedule posted on-line.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "For Olmsted County residents with no insurance",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Ask about interpreter services",
    "Please provide a description of services your organization offers": "General medical, general adult assessments, psychiatry and psychology, smoking cessation (also open to residents with insurance), pediatrics, eye care, diabetes, breast clinic."
  },
  {
    "Record ID": 101,
    "Type of Service": "Health Services",
    "Name of Organization": "Olmsted County Public Health",
    "Address": "2100 Campus Drive S.E.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Rochester",
    "State": "MN",
    "Zip Code": 55904,
    "County": "Olmsted",
    "Main phone number": "507-328-7500",
    "Crisis Line Phone Number": "",
    "Organization website": "www.co.olmsted.mn.us",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Eligibility varies with program",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "depends on service",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Child and teen checkups clinic, immunizations clinic, communicable disease information and screening including STIs, environmental concerns, public health nurse information, home visits for pregnancy, parenting, and health education and promotion."
  },
  {
    "Record ID": 102,
    "Type of Service": "Health Services",
    "Name of Organization": "Planned Parenthood North Central States",
    "Address": "1212 7th Street W.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Rochester",
    "State": "MN",
    "Zip Code": 55901,
    "County": "Olmsted",
    "Main phone number": "507-288-5186",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.plannedparenthood.org/health-center/minnesota/rochester/55901/rochester-clinic-2799-90720#",
    "Organization Email": "",
    "Hours of operation": "Mon & Tues: 9:00 a.m. - 4:30 p.m. Wed & Thurs: 10:30 a.m. - 6:00 p.m. Fri: 7:00 a.m. - 2:30 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Walk-in services include: HIV testing, emergency contraception, pregnancy testing. Services Interpreter services available upon request : reproductive health care (men and women), STI testing treatment and vaccines, family planning."
  },
  {
    "Record ID": 103,
    "Type of Service": "Health Services",
    "Name of Organization": "Essentia Health St. Mary’s Pelican Rapids Clinic",
    "Address": "301 North Broadway",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Pelican Rapids",
    "State": "MN",
    "Zip Code": 56572,
    "County": "Otter Tail",
    "Main phone number": "218-863-2000",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.essentiahealth.org/find-facility/profile/essentia-health-st-marys-pelican-rapids-clinic",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:30 a.m. - noon and 1:00 p.m. - 5:00 p.m. Call for appointment.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Spanish on-site; Interpreter services for other languages available upon request",
    "Please provide a description of services your organization offers": "Primary care, ob/gyn, midwives, lab, imaging and radiology, sports medicine, physical therapy, mental health counseling, psychiatry, podiatry, diabetes education"
  },
  {
    "Record ID": 104,
    "Type of Service": "Health Services",
    "Name of Organization": "Sanford Health Pelican Rapids Clinic",
    "Address": "211 E. Mill St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Pelican Rapids",
    "State": "MN",
    "Zip Code": 56572,
    "County": "Otter Tail",
    "Main phone number": "218-863-6100",
    "Crisis Line Phone Number": "",
    "Organization website": "www.sanfordhealth.org",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "primary care, general surgery, orthopedics, ob/gyn, radiology"
  },
  {
    "Record ID": 105,
    "Type of Service": "Health Services",
    "Name of Organization": "Allina Medical Clinic – West St. Paul",
    "Address": "150 East Emerson Ave. West",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55118,
    "County": "Ramsey",
    "Main phone number": "651-241-1800",
    "Crisis Line Phone Number": "",
    "Organization website": "https://account.allinahealth.org/locations/93",
    "Organization Email": "",
    "Hours of operation": "Mon. - Thurs. 7:30 a.m. - 7:00 p.m. Fri. 7:30 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Primary care, pregnancy care, pharmacy"
  },
  {
    "Record ID": 106,
    "Type of Service": "Health Services",
    "Name of Organization": "M Health Fairview Clinic - Bethesda",
    "Address": "580 Rice St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55103,
    "County": "Ramsey",
    "Main phone number": "651-227-6551",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.mhealth.org/childrens/locations/buildings/bethesda-family-medicine-clinic",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "primary care, OB/GYN, sports medicine, social services and behavioral health (CVT Healing Heart embedded in clinic.  Certified Health Care Home.  Legal Aid Attorney on site."
  },
  {
    "Record ID": 107,
    "Type of Service": "Health Services",
    "Name of Organization": "East Side Family Clinic / Minnesota Community Care",
    "Address": "895 East 7th St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55106,
    "County": "Ramsey",
    "Main phone number": "651-602-7500",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.mncare.org/",
    "Organization Email": "",
    "Hours of operation": "Mon., Tues., and Fri. 8:00 a.m. - 5:00 p.m. Wed. & Thurs. 8:00 a.m. - 8:00 p.m. Sat. 8:00 a.m. - 12:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Hmong, Spanish and other languages by request.",
    "Please provide a description of services your organization offers": "Primary care, urgent care visits, medication management, lab,  xray, simple procedures, preventive screening, child and adolescent health, women's health, senior health"
  },
  {
    "Record ID": 108,
    "Type of Service": "Health Services",
    "Name of Organization": "Face-to-Face Health & Counseling",
    "Address": "1165 Arcade St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55106,
    "County": "Ramsey",
    "Main phone number": "651-772-5555",
    "Crisis Line Phone Number": "",
    "Organization website": "www.face2face.org",
    "Organization Email": "",
    "Hours of operation": "Mon. 10:00a.m. - 6:00 p.m. Tues. 10:00 a.m. - 7:00 p.m. Wed. 10:00 a.m. - 6:00 p.m. Thurs. 10:00 a.m. - 7:00 p.m. Fri. 10:00a.m. - 4:00p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Ages 11-24",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Limited primary care, birth control, exams, emergency contraception (Plan B), STI screening and treatment, HIV testing, prenatal care"
  },
  {
    "Record ID": 109,
    "Type of Service": "Health Services",
    "Name of Organization": "Family Tree Clinic",
    "Address": "1619 Dayton Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "#205",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55104,
    "County": "Ramsey",
    "Main phone number": "651-645-0478",
    "Crisis Line Phone Number": "",
    "Organization website": "www.familytreeclinic.org",
    "Organization Email": "",
    "Hours of operation": "Mon., Wed. 8:00 a.m. - 8:30 p.m. Tues., Thurs. 8:00 a.m. - 5:00 p.m. Sat. 10:00 a.m. - 2:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Reproductive health, family planning,  HIV and STD testing, treatment and emergency contraception, trans hormone care, PrEP. Deaf, Deaf Blind and hard of hearing services, LGBT targeted services."
  },
  {
    "Record ID": 110,
    "Type of Service": "Health Services",
    "Name of Organization": "Global Dermatology Clinic HealthPartners Specialty Center",
    "Address": "401 Phalen Boulevard",
    "Suite (Ste.) or Apartment (Apt.) number": "3rd Floor",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55130,
    "County": "Ramsey",
    "Main phone number": "651-254-7580",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.healthpartners.com/care/find/locations/centers/healthpartners/st-paul/dermatology/",
    "Organization Email": "",
    "Hours of operation": "Tues, Wed, Friday from 8-4 PM.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request .",
    "Please provide a description of services your organization offers": "Dermatologist with experience managing skin disorders in refugees and immigrants."
  },
  {
    "Record ID": 111,
    "Type of Service": "Health Services",
    "Name of Organization": "HealthPartners / Center for International Health",
    "Address": "451 North Dunlap St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55104,
    "County": "Ramsey",
    "Main phone number": "651-647-2100",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.healthpartners.com/care/find/locations/centers/healthpartners/st-paul/center-international-health/",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Ages 13 and older.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Many languages on-site; interpreter services for other languages upon request",
    "Please provide a description of services your organization offers": "Adult primary care for non-English speaking and limited English speaking patients. medication evaluation & management, cross cultural health care consults, workers compensation exams."
  },
  {
    "Record ID": 112,
    "Type of Service": "Health Services",
    "Name of Organization": "La Clinica / Minnesota Community Care",
    "Address": "153 Cesar Chavez Street",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55107,
    "County": "Ramsey",
    "Main phone number": "651-222-1816",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.mncare.org/",
    "Organization Email": "",
    "Hours of operation": "Mon., Tues., Fri. 8:00 a.m. - 5:00 p.m.  Wed., Thurs. 8:00 a.m. - 8:00 p.m. Sat. 8:00 a.m. - 12:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Spanish on-site; interpreter services for other languages upon request",
    "Please provide a description of services your organization offers": "primary care,  diabetes care,  family support & mental health counseling, health education, nutrition services, pharmacy, midwives, women’s health, optometry"
  },
  {
    "Record ID": 113,
    "Type of Service": "Health Services",
    "Name of Organization": "McDonough Homes Clinic / Minnesota Community Care",
    "Address": "1544 Timberlake Rd.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55117,
    "County": "Ramsey",
    "Main phone number": "651-558-2191",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.mncare.org/",
    "Organization Email": "",
    "Hours of operation": "Mon., Thurs., Fri. 8:00 a.m. - 4:30 p.m. Tues. & Wed. 8:00 a.m. - 8:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Spanish on-site; interpreter services for other languages upon request",
    "Please provide a description of services your organization offers": "primary care,  diabetes care,  family support & mental health counseling, health education, nutrition services, pharmacy, midwives, women’s health, optometry"
  },
  {
    "Record ID": 114,
    "Type of Service": "Health Services",
    "Name of Organization": "Perinatal and Pediatric HIV Program at Children’s Minnesota",
    "Address": "",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "",
    "State": "",
    "Zip Code": null,
    "County": "Ramsey",
    "Main phone number": "(651) 220-6444",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.childrensmn.org/perinatal-pediatric-hiv-program/",
    "Organization Email": "",
    "Hours of operation": "",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Women living with HIV. Call for intake process.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Care coordination for pregnant HIV+ women and their babies living in Minnesota: medical and social services during pregnancy and six months post-partum.  Provider referral needed; clinic social worker can assist with process"
  },
  {
    "Record ID": 115,
    "Type of Service": "Health Services",
    "Name of Organization": "Open Cities Health Center - Dunlap",
    "Address": "409 N. Dunlap St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55104,
    "County": "Ramsey",
    "Main phone number": "651-290-9200",
    "Crisis Line Phone Number": "",
    "Organization website": "www.opencitieshealth.org",
    "Organization Email": "",
    "Hours of operation": "Mon. , Wed., Fri. : 8 am - 5 pm; Tues. and Thurs. : 8 am - 8 pm; Sat. 8 am - 5 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Spanish and Hmong on-site; interpreter services for other languages upon request. Hmong line: 651-290-9204; Spanish line: 651-290-4625",
    "Please provide a description of services your organization offers": "Primary care, pediatrics, adolescent medicine, Geriatrics, pain management, endocrinology, care coordination.  Dental, optometry, behavioral health on-site."
  },
  {
    "Record ID": 116,
    "Type of Service": "Health Services",
    "Name of Organization": "Open Cities Health Center - North End",
    "Address": "916 Rice Street",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55117,
    "County": "Ramsey",
    "Main phone number": "651-290-9201",
    "Crisis Line Phone Number": "",
    "Organization website": "www.opencitieshealth.org",
    "Organization Email": "",
    "Hours of operation": "Mon - Fri.: 8 am - 5 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Spanish and Hmong on-site; interpreter services for other languages upon request. Hmong line: 651-290-9204; Spanish line: 651-290-4625",
    "Please provide a description of services your organization offers": "Primary care, pediatrics, adolscent medicine, Geriatrics, pain management, endocrinology, care coordination."
  },
  {
    "Record ID": 117,
    "Type of Service": "Health Services",
    "Name of Organization": "Planned Parenthood of North Central States",
    "Address": "671 Vandalia St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55114,
    "County": "Ramsey",
    "Main phone number": "(651) 698-2406",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.plannedparenthood.org/health-center/minnesota/saint-paul/55114/st-paul-health-center-vandalia-4055-90720",
    "Organization Email": "",
    "Hours of operation": "Mon. - Sat. 8:00 a.m. - 4:30 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Walk-in servies include: HIV testing, emergency contraception, pregnancy testing. Services Interpreter services available upon request : family planning, men’s health care, STI testing treatment and vaccines, womens health care, pregnancy testing and services"
  },
  {
    "Record ID": 118,
    "Type of Service": "Health Services",
    "Name of Organization": "Planned Parenthood of North Central States",
    "Address": "91 Viking Dr W",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55117,
    "County": "Ramsey",
    "Main phone number": "651-489-1328",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.plannedparenthood.org/health-center/minnesota/saint-paul/55117/rice-street-viking-drive-west-2706-90720",
    "Organization Email": "",
    "Hours of operation": "Mon. - Thurs. 10:00 a.m. - 6:00 p.m. Fri. 10:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Walk-in servies include: HIV testing, emergency contraception, pregnancy testing. Services Interpreter services available upon request : family planning, men’s health care, STI testing treatment and vaccines, womens health care."
  },
  {
    "Record ID": 119,
    "Type of Service": "Health Services",
    "Name of Organization": "Clinic 555",
    "Address": "555 Cedar St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55101,
    "County": "Ramsey",
    "Main phone number": "651-266-1255",
    "Crisis Line Phone Number": "",
    "Organization website": "www.clinic555.org",
    "Organization Email": "",
    "Hours of operation": "Mon. & Wed. 8:15 a.m. - 11:30 am; 1 - 3:30 p.m. Tues. & Thurs. 8:15 a.m. - 11:30 am; 1 - 6:30 p.m. Fri. 8:15 a.m. - 12:15 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Adults and teens",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants, some services free)",
    "Interpretation services": "Spanish on-site; interpreter services for other languages upon request",
    "Please provide a description of services your organization offers": "HIV testing, STI testing and treatment, family planning, pregnancy testing, emergency contraception, annual gynecological exams and pap smears, HIV prevention pills, breast cancer screening."
  },
  {
    "Record ID": 120,
    "Type of Service": "Health Services",
    "Name of Organization": "United Primary Care",
    "Address": "1026 W. 7th St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55102,
    "County": "Ramsey",
    "Main phone number": "651-241-1000",
    "Crisis Line Phone Number": "",
    "Organization website": "www.unitedfamilymedicine.org",
    "Organization Email": "",
    "Hours of operation": "Mon. - Thurs.: 8:00 a.m. - 8:00 p.m. Fri.: 8:00 a.m. - 5:00 p.m. Sat.: 8:00 a.m. - 12:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Spanish on-site; interpreter services for other languages upon request",
    "Please provide a description of services your organization offers": "Spanish on-site; interpreter services for other languages upon request"
  },
  {
    "Record ID": 121,
    "Type of Service": "Health Services",
    "Name of Organization": "Allina Health  - Faribault Clinic",
    "Address": "100 State Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Faribault",
    "State": "MN",
    "Zip Code": 55021,
    "County": "Rice",
    "Main phone number": "507-334-3921",
    "Crisis Line Phone Number": "",
    "Organization website": "https://account.allinahealth.org/locations/63",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri 7:30 a.m. - 6:00 p.m. Urgent Care:  Mon. - Fri. 8 am - 8 pm; Sat & Sun, 9 am - 5 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Primary and specialty care service, eye care services and optical shop"
  },
  {
    "Record ID": 122,
    "Type of Service": "Health Services",
    "Name of Organization": "Allina Health - Northfield Clinic",
    "Address": "1400 Jefferson Rd.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Northfield",
    "State": "MN",
    "Zip Code": 55057,
    "County": "Rice",
    "Main phone number": "507-663-9000",
    "Crisis Line Phone Number": "",
    "Organization website": "https://account.allinahealth.org/locations/78",
    "Organization Email": "",
    "Hours of operation": "Mon. - Thurs. 7:30 a.m. - 6:30 p.m. Fri. 7:30 a.m. - 5:00 p.m. Sat. 8:00 a.m. - 2 p,; Walk-in care:  Mon. - Fri: 7:30 am - 9 am; Sat. 8 am - 2 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Primary and specialty care services including lab and imaging, ob/gyn, travel medicine, acupuncture, psychology and psychiatry"
  },
  {
    "Record ID": 123,
    "Type of Service": "Health Services",
    "Name of Organization": "Health Finders Clinic",
    "Address": "710 Division St. S",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Northfield",
    "State": "MN",
    "Zip Code": 55057,
    "County": "Rice",
    "Main phone number": "507-323-8100",
    "Crisis Line Phone Number": "",
    "Organization website": "www.healthfindersmn.org",
    "Organization Email": "",
    "Hours of operation": "As of Feb 2020: Tues. and Th.: 4:30 pm - 7:30 pm.  May change; verify on website.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Income below 200% federal poverty limits, uninsured or underinsured.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Public insurance, financial assistance",
    "Interpretation services": "Spanish and Somali on-site; interpreter services for other languages upon request",
    "Please provide a description of services your organization offers": "Primary care, community connections, medications assistance program, lab services. Diabetes education group for Latinos, Latino teen walk-in clinic, women only exercise groups, MNsure enrollment in Somali and Spanish."
  },
  {
    "Record ID": 124,
    "Type of Service": "Health Services",
    "Name of Organization": "Rice County Public Health",
    "Address": "320 3rd  St. NW",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Faribault",
    "State": "MN",
    "Zip Code": 55021,
    "County": "Rice",
    "Main phone number": "507-332-6111",
    "Crisis Line Phone Number": "",
    "Organization website": "http://www.co.rice.mn.us/278/Family-Child-Health-Services",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. - 4:30 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Disease prevention and control including immunizations, health promotion and wellness, home health care, family and child health care services, and long term care services."
  },
  {
    "Record ID": 125,
    "Type of Service": "Health Services",
    "Name of Organization": "River Valley Health Services - Anchor Center",
    "Address": "752 Canterbury Rd.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Shakopee",
    "State": "MN",
    "Zip Code": 55379,
    "County": "Scott",
    "Main phone number": "952-496-8669",
    "Crisis Line Phone Number": "",
    "Organization website": "https://rivervalleyhealthservices.org/",
    "Organization Email": "",
    "Hours of operation": "Mon.: 2:00 p.m. - 6:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Spanish on-site; interpreter services for other languages upon request",
    "Please provide a description of services your organization offers": "Services are provided by a Public Health Nurse and a Spanish Interpreter/Community Outreach Worker. Screening services, nurse assessments, immunization, health education, pregnancy verification for medical assistance, over-the-counter prescription assistance, MNsure navigation, community resource connections"
  },
  {
    "Record ID": 126,
    "Type of Service": "Health Services",
    "Name of Organization": "Scott County Public Health - Walk-in clinic",
    "Address": "792 Canterbury Rd S",
    "Suite (Ste.) or Apartment (Apt.) number": "Rm 231",
    "City": "Shakopee",
    "State": "MN",
    "Zip Code": 55379,
    "County": "Scott",
    "Main phone number": "952-496-8555",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.scottcountymn.gov/375/Walk-in-Clinic",
    "Organization Email": "",
    "Hours of operation": "Tues. and Thurs.: 8:30 - 10:30 am",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Scott Cty resident",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "depends on service",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Immunizations, blood pressure monitoring, glucose monitoring, TB skin tests, general health questions"
  },
  {
    "Record ID": 127,
    "Type of Service": "Health Services",
    "Name of Organization": "Scott County Public Health - Immunizations",
    "Address": "792 Canterbury Rd S",
    "Suite (Ste.) or Apartment (Apt.) number": "Room 231",
    "City": "Shakopee",
    "State": "MN",
    "Zip Code": 55379,
    "County": "Scott",
    "Main phone number": "952-496-8555",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.scottcountymn.gov/348/Immunization-Clinic",
    "Organization Email": "",
    "Hours of operation": "2 Mondays per month, 2 - 5 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Scott residents age 6 wks - adult, who are uninsured or whose insurance does not cover immunizations",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free; donation accepted",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "All recommended and required vaccines"
  },
  {
    "Record ID": 128,
    "Type of Service": "Health Services",
    "Name of Organization": "CentraCare Family Health Center",
    "Address": "1555 Northway Drive",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 200",
    "City": "St. Cloud",
    "State": "MN",
    "Zip Code": 56303,
    "County": "Stearns",
    "Main phone number": "320-240-3157",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.centracare.com/locations/centracare-family-health-clinic/?L=true",
    "Organization Email": "",
    "Hours of operation": "Mon. – Fri.: 7:30 a.m. – 4:30 p.m",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "primary care, home health care, OB/ GYN services,  diabetes care, community health workers."
  },
  {
    "Record ID": 129,
    "Type of Service": "Health Services",
    "Name of Organization": "HealthPartners Central Minnesota Clinics",
    "Address": "2251 Connecticut Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Sartell",
    "State": "MN",
    "Zip Code": 56377,
    "County": "Stearns",
    "Main phone number": "320-253-5220",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.healthpartners.com/care/find/locations/primary-care-clinics/healthpartners/sartell/clinics/",
    "Organization Email": "",
    "Hours of operation": "Mon. - Tues.: 8:00 a.m. - 6:00 p.m. Wed. - Thurs.: 8 am - 5 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "primary care, internal medicine, pediatrics, Ob/GYN, sleep medicine"
  },
  {
    "Record ID": 130,
    "Type of Service": "Health Services",
    "Name of Organization": "Planned Parenthood North Central States",
    "Address": "451 E. St. Germain St",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 100",
    "City": "St. Cloud",
    "State": "MN",
    "Zip Code": 56304,
    "County": "Stearns",
    "Main phone number": "320-252-9504",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.plannedparenthood.org/health-center/minnesota/saint-cloud/56304/st-cloud-clinic-2609-90720",
    "Organization Email": "",
    "Hours of operation": "Mon - Fri: 9:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Walk-in services include: HIV testing, emergency contraception, pregnancy testing. Services Interpreter services available upon request : birth control, men and women’s health care, STI testing treatment and vaccines, LGBTQ services"
  },
  {
    "Record ID": 131,
    "Type of Service": "Health Services",
    "Name of Organization": "Stearns County Human Services and Public Health",
    "Address": "PO Box 1107",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Cloud",
    "State": "MN",
    "Zip Code": 56302,
    "County": "Stearns",
    "Main phone number": "320-203-6942",
    "Crisis Line Phone Number": "",
    "Organization website": "www.co.stearns.mn.us",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. - 4:30 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Dependent on program",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Immunizations, Women, Infants, & Children, Maternal/child home visits,  TB/LTBI follow-up, other infectious disease follow-up, child & teen check-up outreach, and senior health clinics."
  },
  {
    "Record ID": 132,
    "Type of Service": "Health Services",
    "Name of Organization": "M Health Fairview Clinic -Cottage Grove",
    "Address": "6936 Pine Arbor Drive S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Cottage Grove",
    "State": "MN",
    "Zip Code": 55016,
    "County": "Washington",
    "Main phone number": "651-326-5800",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.fairview.org/locations/healtheast-clinic-cottage-grove",
    "Organization Email": "",
    "Hours of operation": "Mon. - Tues & Thurs. - Fri. 8:00 a.m. - 5:00 p.m.; Wed: 7 am - 5 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Primary care, obstetrical care, and diabetes education"
  },
  {
    "Record ID": 133,
    "Type of Service": "Health Services",
    "Name of Organization": "M Health Fairview Clinic -Oakdale",
    "Address": "1099 Helmo Ave. N.",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 100",
    "City": "Oakdale",
    "State": "MN",
    "Zip Code": 55128,
    "County": "Washington",
    "Main phone number": "651-326-5300",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.fairview.org/locations/healtheast-clinic-oakdale",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 7:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Primary care, medication management"
  },
  {
    "Record ID": 134,
    "Type of Service": "Health Services",
    "Name of Organization": "M Health Fairview Clinic - Woodwinds",
    "Address": "1825 Woodwinds Drive",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Woodbury",
    "State": "MN",
    "Zip Code": 55125,
    "County": "Washington",
    "Main phone number": "651-232-6700",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.fairview.org/locations/woodwinds-health-campus/healtheast-clinic-woodwinds",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 7:30 a.m. - 5:00 p.m.; Walk-in care:  Mon. - Fri.: 7 am - 7 pm; Sat. and Sun.: 8 am - 4 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Primary care, pediatrics, midwives, lactation services, nutrition, diabetes education, endocrinology, podiatry"
  },
  {
    "Record ID": 135,
    "Type of Service": "Health Services",
    "Name of Organization": "M Health Fairview Clinic -Tamarack",
    "Address": "9900 Tamarack Rd",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Woodbury",
    "State": "MN",
    "Zip Code": 55125,
    "County": "Washington",
    "Main phone number": "651-471-5800",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.fairview.org/locations/healtheast-clinic-tamarack",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 7:30 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "primary care, obstetrics, lactation services, pediatric care, medication management"
  },
  {
    "Record ID": 136,
    "Type of Service": "Health Services",
    "Name of Organization": "HealthPartners / Woodbury",
    "Address": "8450 Seasons Parkway",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Woodbury",
    "State": "MN",
    "Zip Code": 55125,
    "County": "Washington",
    "Main phone number": "651-702-5300",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.healthpartners.com/care/find/locations/primary-care-clinics/healthpartners/woodbury/?shouldIndex=true",
    "Organization Email": "",
    "Hours of operation": "Mon. - Thurs. 8:00 a.m. - 8:00 p.m.; Fri 8 am - 4 pm Urgent Care: Mon. - Fri. 8 a.m - 8:00 p.m. Sat. and Sun.:  8:00 a.m - 5:00 p.m. See webpage for pediatric walk-in schedule",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Primary care, Pediatrics, OB/ GYN, pharmacy, lab, radiology, and urgent care services."
  },
  {
    "Record ID": 137,
    "Type of Service": "Health Services",
    "Name of Organization": "Lakeview Health - Stillwater",
    "Address": "1500 Curve Crest Boulvard",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Stillwater",
    "State": "MN",
    "Zip Code": 55408,
    "County": "Washington",
    "Main phone number": "651-439-1234",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.lakeviewhealth.org/stillwater",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 7:30 a.m. - 5:00 p.m. Urgent Care: Mon. - Fri. 11:00 a.m. - 8:00 p.m. Sat. & Sun. 8:00 - 4:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "primary care, internal medicine, pediatrics, OB care, lab, pharmacy, radiology"
  },
  {
    "Record ID": 138,
    "Type of Service": "Health Services",
    "Name of Organization": "Planned Parenthood North Central States",
    "Address": "1795 Radio Drive",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. D",
    "City": "Woodbury",
    "State": "MN",
    "Zip Code": 55125,
    "County": "Washington",
    "Main phone number": "651-696-5550",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.plannedparenthood.org/health-center/minnesota/woodbury/55125/woodbury-clinic-3096-90720",
    "Organization Email": "",
    "Hours of operation": "Mon - Fri: 12:00 p.m. - 6:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request",
    "Please provide a description of services your organization offers": "Walk-in services include: HIV testing, emergency contraception, pregnancy testing. Services Interpreter services available upon request : birth control, men and women’s health care, STI testing treatment and vaccines, LGBTQ services"
  },
  {
    "Record ID": 139,
    "Type of Service": "Dental Services",
    "Name of Organization": "Dakota County Public Health – Children’s Dental Services",
    "Address": "14955 Galaxie Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "WIC Lobby",
    "City": "Apple Valley",
    "State": "MN",
    "Zip Code": 55124,
    "County": "Dakota",
    "Main phone number": "612-746-1530",
    "Crisis Line Phone Number": "",
    "Organization website": "www.childrensdentalservices.org",
    "Organization Email": "",
    "Hours of operation": "Call to verify hours and make an appointment.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "For infants and children up to the age of 26. Call to verify other eligibility requirements.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Ask abou interpreter services when scheduling.",
    "Please provide a description of services your organization offers": "Dental exams, cleaning, x rays, sealants, restoration and fluroide treatment."
  },
  {
    "Record ID": 140,
    "Type of Service": "Dental Services",
    "Name of Organization": "Community University Health Care Center (CUHCC)",
    "Address": "2001 Bloomington Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55404,
    "County": "Hennepin",
    "Main phone number": "612-301-0198",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. - 5:00 p.m.; Saturday morning appointments for children",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Cleanings, x-rays and exams, sealants, fluoride treatment, fillings, crowns, partials, dentures, extractions, root canals."
  },
  {
    "Record ID": 141,
    "Type of Service": "Dental Services",
    "Name of Organization": "Children’s Dental Services",
    "Address": "636 Broadway St. NE",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "NE Minneapolis",
    "State": "MN",
    "Zip Code": 55413,
    "County": "Hennepin",
    "Main phone number": "612-746-1530",
    "Crisis Line Phone Number": "",
    "Organization website": "www.childrensdentalservices.org",
    "Organization Email": "",
    "Hours of operation": "Mon., Thurs. & Fri. 8:30 a.m. - 5:00 p.m. Tues. & Wed. 8:30 a.m. - 7:00 p.m. Sat. 9:00 a.m. - 1:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Children, birth to 26 years ols, and pregnant women.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Emergency dental, extractions, sealants, fluoride, cleanings, fillings, crowns, hospital-based care and endodontia. Referrals for orthodontia and oral surgery. Culturally targeted dental care and oral health education."
  },
  {
    "Record ID": 142,
    "Type of Service": "Dental Services",
    "Name of Organization": "Diamondhead Clinic",
    "Address": "200 W. Burnsville Parkway",
    "Suite (Ste.) or Apartment (Apt.) number": "Lower Level of Diamondhead Education Center",
    "City": "Burnsville",
    "State": "MN",
    "Zip Code": 55337,
    "County": "Dakota",
    "Main phone number": "612-746-1530",
    "Crisis Line Phone Number": "",
    "Organization website": "www.co.dakota.mn.us",
    "Organization Email": "",
    "Hours of operation": "Tues. &. Thurs. 1:00 - 4:30 p.m. Walk-in clinic. No appointment necessary.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Ages 0-21 if living in Burnsville, Eagan, Savage, or ISD 191 school district. 18-21 must be enrolled in ISD 191.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "English, Spanish and Somali on site. Interpreter services for other languages upon request.",
    "Please provide a description of services your organization offers": "Dental Care. Check specific services available when scheduling."
  },
  {
    "Record ID": 143,
    "Type of Service": "Dental Services",
    "Name of Organization": "Community Dental Care",
    "Address": "3359 West Broadway",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Robbinsdale",
    "State": "MN",
    "Zip Code": 55422,
    "County": "Hennepin",
    "Main phone number": "763-270-5776",
    "Crisis Line Phone Number": "",
    "Organization website": "www.cdentc.org",
    "Organization Email": "inforob@cdentc.org",
    "Hours of operation": "Mon. - Thurs.: 7:30 a.m. - 7:30 p.m. and  Fri.: 7:30 a.m. - 2:30 p.m.  Emergency Hrs: M-Th 7:30 a.m. - 5:00 p.m. and  Friday: 7:30 a.m. - 11:00 a.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Hmong, Spanish and Somali on site. Interpreter services for other languages upon request.",
    "Please provide a description of services your organization offers": "Preventative, restorative, emergency care, extractions, root canals, and dentures. Culturally Specific Services: PICOH program (program to improve community oral health) dedicated to in-house outreach education for Hmong/Karen/Somali/Oromo/Hispanic populations."
  },
  {
    "Record ID": 144,
    "Type of Service": "Dental Services",
    "Name of Organization": "Indian Health Board",
    "Address": "1315 East 24th St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55404,
    "County": "Hennepin",
    "Main phone number": "612-721-9800",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "Mon., Wed., Thurs., Fri. 9:00 a.m. - 5:00 p.m. Tues. 9:00 a.m. - 7:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Spanish, Lakota, and Ojibwe on site. Interpreter services of other languages upon request.",
    "Please provide a description of services your organization offers": "Adult and pediatric dentistry, preventative care education, emergency dental work. Focus on serving the American Indian Community."
  },
  {
    "Record ID": 145,
    "Type of Service": "Dental Services",
    "Name of Organization": "Normandale Community College - Dental Hygiene",
    "Address": "9700 France Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Bloomington",
    "State": "MN",
    "Zip Code": 55431,
    "County": "Hennepin",
    "Main phone number": "952-358-8608",
    "Crisis Line Phone Number": "",
    "Organization website": "www.normandale.mnscu.edu",
    "Organization Email": "",
    "Hours of operation": "Appointment times vary by semester and availability. Call for openings.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Cash or credit card only (VISA, Mastercard, Discover Card).",
    "Interpretation services": "None",
    "Please provide a description of services your organization offers": "Cleanings, x-rays, exams, fluoride treatments, sealants and fillings."
  },
  {
    "Record ID": 146,
    "Type of Service": "Dental Services",
    "Name of Organization": "North Metro Pediatrics",
    "Address": "10081 Dogwood St.",
    "Suite (Ste.) or Apartment (Apt.) number": "Suite 100",
    "City": "Coon Rapids",
    "State": "MN",
    "Zip Code": 55448,
    "County": "Anoka",
    "Main phone number": "763-783-3722",
    "Crisis Line Phone Number": "",
    "Organization website": "www.northmetropeds.org",
    "Organization Email": "",
    "Hours of operation": "M, T, W, F: 9:00 a.m. - 4:30 p.m.   Th: 9:00 a.m. - 7:00 p.m.  Fri: 9:00 a.m. - 2:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Children from birth to 21 years old.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Ask about specific services available when scheduling."
  },
  {
    "Record ID": 147,
    "Type of Service": "Dental Services",
    "Name of Organization": "NorthPoint Health & Wellness Center",
    "Address": "1313 Penn Ave. N.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55411,
    "County": "Hennepin",
    "Main phone number": "612-543-2500",
    "Crisis Line Phone Number": "",
    "Organization website": "www.northpointhealth.org",
    "Organization Email": "www.northpointhealth.org",
    "Hours of operation": "Mon., Fri.: 8:00 a.m. - 5:00 p.m.   Tues., Wed. & Thurs.: - 8:00 a.m. - 7:00 p.m.   Sat.: 8:00 a.m. - 12:00 p.m",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants), Minimum $20 payment at time of service",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Preventative care, restorative care, emergency care, digital x ray, dentures, pediatric dental work."
  },
  {
    "Record ID": 148,
    "Type of Service": "Dental Services",
    "Name of Organization": "Cedar Riverside People’s Center Clinic",
    "Address": "425 20th Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55454,
    "County": "Hennepin",
    "Main phone number": "612-332-4973",
    "Crisis Line Phone Number": "",
    "Organization website": "www.peoples-center.org",
    "Organization Email": "",
    "Hours of operation": "Mon. & Fri. 8:30 am - 5 pm  Tues., Wed., and Thurs., 8:30 am - 8 pm  Sat. 9 am - 1 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants, some services free)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Comprehensive dental services including exams and x-rays, sealants and flouride, fillings, root canals, bridges and crowns, cleaning and extractions."
  },
  {
    "Record ID": 149,
    "Type of Service": "Dental Services",
    "Name of Organization": "Sharing & Caring Hands – Dental",
    "Address": "525 North 7th St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55405,
    "County": "Hennepin",
    "Main phone number": "612-338-4640",
    "Crisis Line Phone Number": "",
    "Organization website": "www.freedentalcare.us/li/sharing_and_caring_hands",
    "Organization Email": "info@sharingandcaringhands.org",
    "Hours of operation": "Mon-Thurs: 10:30-11:30 and 1:30-2:30",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "For people with little or no dental coverage.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Some Spanish on site.",
    "Please provide a description of services your organization offers": "Extractions and fillings only."
  },
  {
    "Record ID": 150,
    "Type of Service": "Dental Services",
    "Name of Organization": "Southside Community Dental Clinic",
    "Address": "4243 4th Ave S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55409,
    "County": "Hennepin",
    "Main phone number": "612-822-9030",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 7:00 a.m. - 5:00 p.m.  Second Saturday of each month 8:00 a.m. - noon",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Preventive care, cleaning, instruction/education, X-rays, sealants, fluoride, restorative care, fillings, extractions, root canals, crowns/bridges, dentures/partials, referrals, patient support services, transportation, help with insurance."
  },
  {
    "Record ID": 151,
    "Type of Service": "Dental Services",
    "Name of Organization": "University of Minnesota School of Dentistry Clinic",
    "Address": "515 Delaware St. SE",
    "Suite (Ste.) or Apartment (Apt.) number": "7th Floor Moos Tower",
    "City": "SE Minneapolis",
    "State": "MN",
    "Zip Code": 55455,
    "County": "Hennepin",
    "Main phone number": "612-625-2495",
    "Crisis Line Phone Number": "612-273-3000",
    "Organization website": "www.dentalclinics.umn.edu",
    "Organization Email": "umdentcl@umn.edu",
    "Hours of operation": "Mon. - Fri. 9:00 a.m. - 4:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance  Public insurance (MA, MNCare)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Full range of dental services available, including oral surgery and orthodontics. Discounted rate. Students working with professionals and teachers."
  },
  {
    "Record ID": 152,
    "Type of Service": "Dental Services",
    "Name of Organization": "State Operated Services (SOS) Dental Clinics - Willmar Community Dental Clinic",
    "Address": "1801 Technology Drive",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Willmar",
    "State": "MN",
    "Zip Code": 56201,
    "County": "Kandiyohi",
    "Main phone number": "320-231-5315",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "Mon., Wed., Thurs.: 8:00 a.m. -4:00 p.m.  Fri 8:00 pm-1:30pm.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Services for adults with developmental disabilities, severe/persistent mental ilness, traumatic brain injury, and  those in treatment for chemical dependency.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Delta Dental PPO, Delta Dental Premier",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "State Operated Services in five community dental clinics, for individuals with developmental disabilities, severe persistent mental illness and traumatic brain injury who cannot get care  from other community providers."
  },
  {
    "Record ID": 153,
    "Type of Service": "Dental Services",
    "Name of Organization": "Good Samaritan Dental Clinic",
    "Address": "120 N. Broadway, Ste. B",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Rochester",
    "State": "MN",
    "Zip Code": 55906,
    "County": "Olmsted",
    "Main phone number": "507-529-4100",
    "Crisis Line Phone Number": "",
    "Organization website": "www.centralusa.salvationarmy.org/northern/GoodSamaritanclinic",
    "Organization Email": "",
    "Hours of operation": "Must call for an appt. See website for schedule, posted monthly.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants, some services free)",
    "Interpretation services": "None",
    "Please provide a description of services your organization offers": "Emergency dental care,  X-rays, and extractions."
  },
  {
    "Record ID": 154,
    "Type of Service": "Dental Services",
    "Name of Organization": "Community Dental Care",
    "Address": "1926 College View Rd. S.E.",
    "Suite (Ste.) or Apartment (Apt.) number": "HC# 116",
    "City": "Rochester",
    "State": "MN",
    "Zip Code": 55904,
    "County": "Olmsted",
    "Main phone number": "507-258-4046",
    "Crisis Line Phone Number": "",
    "Organization website": "www.cdentc.org",
    "Organization Email": "infoROCH@cdentc.org",
    "Hours of operation": "Mon. - Tues.: 7:00 a.m. - 7:00 p.m.  Wed. - Thurs. 8:00 a.m. - 5:00 p.m.  Fri.: 8:00 a.m. - 2:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Preventative, Restorative, and Emergency dental services. Multicultural Staff and community programs."
  },
  {
    "Record ID": 155,
    "Type of Service": "Dental Services",
    "Name of Organization": "Fergus Falls Community Dental Clinic",
    "Address": "1121 Pebble Lake Rd",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Fergus Falls",
    "State": "MN",
    "Zip Code": 56537,
    "County": "Otter Tail",
    "Main phone number": "218-739-7254",
    "Crisis Line Phone Number": "",
    "Organization website": "WWW.infolink.dhs.int.state.mn.us",
    "Organization Email": "trish.mcclelland@state.mn.us",
    "Hours of operation": "Mon. - Thurs.: 8:00 a.m. - 4:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Delta Dental PPO, Delta Dental Premier",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "State Operated Services in five community dental clinics, for individuals with developmental disabilities, severe persistent mental illness and traumatic brain injury who cannot get care  from other community providers."
  },
  {
    "Record ID": 156,
    "Type of Service": "Dental Services",
    "Name of Organization": "Century Technical College",
    "Address": "3300 Century Ave. N.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "White Bear Lake",
    "State": "MN",
    "Zip Code": 55110,
    "County": "Ramsey",
    "Main phone number": "651-779-5787",
    "Crisis Line Phone Number": "",
    "Organization website": "www.century.edu/community-resources",
    "Organization Email": "dental.hygene@century.edu",
    "Hours of operation": "Call for hours and appointments; some evening hours available. Mostly afternoons.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Cash or check only.",
    "Interpretation services": "Ask about interpreter services when scheduling.",
    "Please provide a description of services your organization offers": "Cleaning, X-rays, sealants, fluoride treatments, non-surgical treatment for gum problems, referrals to other clinics for additional care."
  },
  {
    "Record ID": 157,
    "Type of Service": "Dental Services",
    "Name of Organization": "Community Dental Care",
    "Address": "1670 Beam Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 204",
    "City": "Maplewood",
    "State": "MN",
    "Zip Code": 55109,
    "County": "Ramsey",
    "Main phone number": "651-925-8400",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "infoMW@cdentc.org",
    "Hours of operation": "Mon. - Thurs.: 7:30 a.m.- 9:30 p.m.   Fri.: 7:30 a.m. - 5:30 p.m.  Emergency hrs: M-Th -7:30 am - 5:00 pm  and Friday 7:30 am - noon",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Preventative, Restorative, and Emergency dental services. Multicultural Staff and community programs."
  },
  {
    "Record ID": 158,
    "Type of Service": "Dental Services",
    "Name of Organization": "Community Dental Care",
    "Address": "828 Hawthorne Avenue East",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55106,
    "County": "Ramsey",
    "Main phone number": "651-774-2959",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "infoSP@cdentc.org",
    "Hours of operation": "Mon.& Wed.: 8:15 a.m. -7:00 p.m.   Tues. & Thurs.: 8:15 a.m.- 5:00 p.m.   Fri. & Sat: 8:15 a.m. - 1:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Preventative, Restorative, and Emergency dental services. Multicultural Staff and community programs."
  },
  {
    "Record ID": 159,
    "Type of Service": "Dental Services",
    "Name of Organization": "East Side Family Clinic/Dental",
    "Address": "895 East 7th Street",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55106,
    "County": "Ramsey",
    "Main phone number": "651-602-7500",
    "Crisis Line Phone Number": "",
    "Organization website": "www.westsidechs.org",
    "Organization Email": "",
    "Hours of operation": "Mon., Tues., and Fri.: 8:00 a.m. - 5:00 p.m.   Wed. and Thu. 8:00 a.m. - 8:00 p.m.  Sat. 8:00 am - noon",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Preventative, Restorative, and Emergency dental services."
  },
  {
    "Record ID": 160,
    "Type of Service": "Dental Services",
    "Name of Organization": "Hope Dental Clinic",
    "Address": "800 Minehaha Ave. E",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 465",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55106,
    "County": "Ramsey",
    "Main phone number": "651-789-7605",
    "Crisis Line Phone Number": "",
    "Organization website": "www.hopedentalclinic.org",
    "Organization Email": "",
    "Hours of operation": "Mon. - Thurs.: 8:00 a.m. - 9:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "For people with no dental insurance coverage.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "$20 payment per appointment if able to pay; otheriwse free.",
    "Interpretation services": "Spanish on site. Ask about interpreter services for other languages when scheduling.",
    "Please provide a description of services your organization offers": "Exams, extractions, fillings, cleanings, sealants, and education."
  },
  {
    "Record ID": 161,
    "Type of Service": "Dental Services",
    "Name of Organization": "Lor Dental Clinic",
    "Address": "491 University Avenue West",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. A",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55103,
    "County": "Ramsey",
    "Main phone number": "651-489-3681",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance  Public insurance (MA, MNCare)  Self-pay",
    "Interpretation services": "Laotian and  Hmong on site. Ask about interpreter services for other languages when scheduling.",
    "Please provide a description of services your organization offers": "Comprehensive dental services, orthodontic and implants."
  },
  {
    "Record ID": 162,
    "Type of Service": "Dental Services",
    "Name of Organization": "West Side Dental Clinic",
    "Address": "478 South Robert Street",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55107,
    "County": "Ramsey",
    "Main phone number": "651-602-7500",
    "Crisis Line Phone Number": "",
    "Organization website": "www.westsidechs.org",
    "Organization Email": "",
    "Hours of operation": "Mon., Tues., and Fri.: 8:00 a.m. - 5:00 p.m.   Wed.  8:30 a.m. - 8:00 p.m.  Thurs. 8:30 a.m. - 7:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Cambodian, Hmong and Spanish on site. Ask about interpreter services for other languages when scheduling.",
    "Please provide a description of services your organization offers": "Preventative and Restorative services."
  },
  {
    "Record ID": 163,
    "Type of Service": "Dental Services",
    "Name of Organization": "Southern Cities Dental Clinic",
    "Address": "400 Fourth St. N.W.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Faribault",
    "State": "MN",
    "Zip Code": 55021,
    "County": "Rice",
    "Main phone number": "507-384-6830",
    "Crisis Line Phone Number": "",
    "Organization website": "Http://infolink.dhs.int.state.mn.us/",
    "Organization Email": "",
    "Hours of operation": "Call for hours and appointments.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Delta Dental PPO, Delta Dental Premier",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "State Operated Services in five community dental clinics, for individuals with developmental disabilities, severe persistent mental illness and traumatic brain injury who cannot get care  from other community providers."
  },
  {
    "Record ID": 164,
    "Type of Service": "Disability Services",
    "Name of Organization": "Fraser",
    "Address": "3333 University Ave. SE",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55414,
    "County": "Hennepin",
    "Main phone number": "612-767-7222",
    "Crisis Line Phone Number": "",
    "Organization website": "www.fraser.org",
    "Organization Email": "frasier@frasier.org",
    "Hours of operation": "Mon - Fri 8 am - 5 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Age 6 weeks and older.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Diagnosis and treatment autism, childhood mental health, neuropsychology, develoopmental delays, and seizures. Supervised housing for teens and adults; school for children 6 weeks to 6 years with special needs."
  },
  {
    "Record ID": 165,
    "Type of Service": "Disability Services",
    "Name of Organization": "Children’s Specialty Center",
    "Address": "2530 Chicago Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55404,
    "County": "Hennepin",
    "Main phone number": "612-813-6000",
    "Crisis Line Phone Number": "",
    "Organization website": "www.childrensmn.org",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Birth to 18 years old.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Primary and Specialty care - including disabilities experienced by children. Most specialty referrals must be made by a primary care provider."
  },
  {
    "Record ID": 166,
    "Type of Service": "Disability Services",
    "Name of Organization": "Courage Kenny Rehabilitation Institute",
    "Address": "800 E. 28th St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55407,
    "County": "Hennepin",
    "Main phone number": "612-863-6015",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "Clinic Hours; Mon - Fri. 8:00 a.m. - 5:00 p.m.   Call to schedule intake appointment.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Comprehensive in-patient and out-patient rehabilitation services. Golden Valley location offers primary care along with specialty care. Need referral from health care provider for services."
  },
  {
    "Record ID": 167,
    "Type of Service": "Disability Services",
    "Name of Organization": "Shriner’s Healthcare for Cildren - twin Cities",
    "Address": "2025 E River Pkwy",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55414,
    "County": "Hennepin",
    "Main phone number": "612-596-6100",
    "Crisis Line Phone Number": "",
    "Organization website": "www.shrinershospitalsforchildren.org/minneapolis",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.,  8 am - 4:30 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Birth to 18 years old.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Assessment, treatment, prosthetics and referrals to surgery (if needed) for children with orthopedic and neuro-musculoskeletal conditions."
  },
  {
    "Record ID": 168,
    "Type of Service": "Disability Services",
    "Name of Organization": "Gillette Lifetime Clinic",
    "Address": "435 Phalen Blvd.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55130,
    "County": "Ramsey",
    "Main phone number": "651-636-9443",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 am-5:00 pm.   Call for appointment",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "For adults with disabilities that had early childhood onset. Need referral from primary care provider.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Diagnosis and treatment of disabilities for adults with childhood onset of physical disabilities and cognitive or neurologic conditions. Specialized equipment, wheelchairs, and prosthetics."
  },
  {
    "Record ID": 169,
    "Type of Service": "Disability Services",
    "Name of Organization": "Gillette Children's Specialty Care",
    "Address": "200 University Ave. East",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55101,
    "County": "Ramsey",
    "Main phone number": "651-290-8707",
    "Crisis Line Phone Number": "",
    "Organization website": "www.gillettechildrens.org",
    "Organization Email": "",
    "Hours of operation": "Call for appointment",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Birth to 18 years old.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Diagnosis and treatment of disabilites in children, including cerebral palsy, neuromusculard Disorders, scoliosis, craniosynostosis, brain injury, spina bifida, polio, hydrocephaly, and other physical and neurlogic conditions."
  },
  {
    "Record ID": 170,
    "Type of Service": "Disability Services",
    "Name of Organization": "Gillette's First Seizure Clinic",
    "Address": "200 University Ave. East",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55101,
    "County": "Ramsey",
    "Main phone number": "651-290-8707",
    "Crisis Line Phone Number": "",
    "Organization website": "www.gillettechildrens.org",
    "Organization Email": "",
    "Hours of operation": "Call for appointment",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Birth to 18 years old.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Newly diagnosed seizures in children: neurodevelopmental pediatrics, neurodiagnostics, neurology, neurosurgery, pediatrics and general medicine, radiology and imaging, sleep health, and psychology."
  },
  {
    "Record ID": 171,
    "Type of Service": "Disability Services",
    "Name of Organization": "Minnesota Epilepsy Group",
    "Address": "225 N. Smith Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 201",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55102,
    "County": "Ramsey",
    "Main phone number": "651-241-2590",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "Call for appointment",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interfoeter services available upon request.",
    "Please provide a description of services your organization offers": "Diagnosis, monitoring and ongoing treatment of persons with Epilepsy."
  },
  {
    "Record ID": 172,
    "Type of Service": "Disability Services",
    "Name of Organization": "Disability Specialists Inc.",
    "Address": "9558 Ashawa Road",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Cook",
    "State": "MN",
    "Zip Code": 55723,
    "County": "Statewide",
    "Main phone number": "218-666-2676",
    "Crisis Line Phone Number": "",
    "Organization website": "www.disabilityspecialists.net",
    "Organization Email": "info@disabilityspecialists.net",
    "Hours of operation": "Mon., Tues, Thurs., Fri. 8 am -4 pm  Wed. 8 am-noon",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Discuss with representative. Low income persons do not pay out of pocket.",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Assist individuals with application and appeals for Social Security Disability , and State Medical Review Team process, to access disability benefits. Request waived fees for low income clients."
  },
  {
    "Record ID": 173,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Alexandra House, Inc: Community Program",
    "Address": "10065 Third Street NE",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Blaine",
    "State": "MN",
    "Zip Code": 55434,
    "County": "Anoka",
    "Main phone number": "763-780-2330",
    "Crisis Line Phone Number": "",
    "Organization website": "www.alexandrahouse.org",
    "Organization Email": "",
    "Hours of operation": "",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Ask about interpreter services when calling.",
    "Please provide a description of services your organization offers": "Free, confidential services for victims of domestic and sexual violence including: emergency shelter, legal advocacy, hospital-based advocacy, safety planning, support groups, youth & aging services."
  },
  {
    "Record ID": 174,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Anoka County Economic Assistance",
    "Address": "Government Center, Anoka County  2100 3rd Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Anoka",
    "State": "MN",
    "Zip Code": 55303,
    "County": "Anoka",
    "Main phone number": "763-422-7200",
    "Crisis Line Phone Number": "",
    "Organization website": "www.anokacounty.us/2888/Links-and-Resources",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 8:00 a.m. - 4:30 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Residents of Anoka County",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Link to resources within the county. Also offer: Food programs, cash assistance, healthcare programs, child care assistance."
  },
  {
    "Record ID": 175,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Southern Valley Alliance for Battered Women",
    "Address": "551 East Park Street",
    "Suite (Ste.) or Apartment (Apt.) number": "P.O. box 166",
    "City": "Belle Plaine",
    "State": "MN",
    "Zip Code": 56011,
    "County": "Carver",
    "Main phone number": "952-873-4214",
    "Crisis Line Phone Number": "",
    "Organization website": "www.svabw.org",
    "Organization Email": "",
    "Hours of operation": "",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Residents of Scott and Carver counties.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Spanish on site. Ask about interpreter services for other languages when calling.",
    "Please provide a description of services your organization offers": "Services for battered women and other victims of family abuse with: 24 hr. crisis line, legal intervention and advocacy, support groups, community engagement."
  },
  {
    "Record ID": 176,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "CLUES - Chicanos Latinos Unidos en Servicio",
    "Address": "720 East Lake Street",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55407,
    "County": "Hennepin",
    "Main phone number": "612-746-3500",
    "Crisis Line Phone Number": "612-746-3537",
    "Organization website": "www.clues.org",
    "Organization Email": "info@clues.org",
    "Hours of operation": "Monday - Thursday: 8:30am-7:00pm / Friday: 8:30am-5:00pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Upon referral only by social worker or county.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Spanish on site. Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Sexual assault prevention and support groups adult victims and children witnesses of domestic violence."
  },
  {
    "Record ID": 177,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Community University Health Care Center",
    "Address": "2001 Bloomington Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55404,
    "County": "Hennepin",
    "Main phone number": "612-301-3433",
    "Crisis Line Phone Number": "",
    "Organization website": "www.cuhcc.umn.edu/patient-care-services/victim-advocacy",
    "Organization Email": "cuhcc@umn.edu",
    "Hours of operation": "Mon., Wed. & Fri. 7:15am-5:00pm  Tues. & Thurs 7:15am-7pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants, some services free)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Free and confidential services including: Ensuring immediate safety,  legal services, courts, therapy, community resources, support groups."
  },
  {
    "Record ID": 178,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Cornerstone",
    "Address": "1000 East 80th Street",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Bloomington",
    "State": "MN",
    "Zip Code": 55420,
    "County": "Hennepin",
    "Main phone number": "(952) 884-0376",
    "Crisis Line Phone Number": "1-866-223-1111",
    "Organization website": "www.cornerstonemn.org",
    "Organization Email": "",
    "Hours of operation": "",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Focus on youth and adults. 24 hr. crisis line, emergency shelters, crime victims support line, legal advocacy, counseling, therapy. Services for sexually exploited youth: school based services, support groups,advocacy."
  },
  {
    "Record ID": 179,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Hennepin County Domestic Abuse Center",
    "Address": "Hennepin County Government Center, 300 South Sixth Street",
    "Suite (Ste.) or Apartment (Apt.) number": "A-Level A0650 LL",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55487,
    "County": "Hennepin",
    "Main phone number": "612-348-5073",
    "Crisis Line Phone Number": "Metro crisis line: 612-379-6363  24 hr. domestic violence line: 1-866-223-1111",
    "Organization website": "www.hennepinattorney.org",
    "Organization Email": "",
    "Hours of operation": "8 am-4:30 pm plus 24hr. Crisi line (see phone #)",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Advocacy for adults and youth, assistance with orders for protection, legal advice from city and county attorneys, safety and security, assists in finding temporary housing,"
  },
  {
    "Record ID": 180,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Phyllis Wheatley Community Center",
    "Address": "1301 10th Ave N",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55411,
    "County": "Hennepin",
    "Main phone number": "612-374-4342",
    "Crisis Line Phone Number": "",
    "Organization website": "www.phylliswheatley.org",
    "Organization Email": "",
    "Hours of operation": "Mon-Fri 8:30 am - 5 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Cases must be assigned by Hennepin County.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Early childhood services, youth services, adult and family services. Men's program. Women's program. Youth program."
  },
  {
    "Record ID": 181,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Tubman Family Alliance",
    "Address": "3111 1st Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55408,
    "County": "Hennepin",
    "Main phone number": "",
    "Crisis Line Phone Number": "612-825-0000",
    "Organization website": "www.tubman.org",
    "Organization Email": "",
    "Hours of operation": "Mon. - Thurs.: 8:00 a.m. - 5:00 p.m.   Fri.: 8:00 a.m. - 12:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Safety Plan, shelter & housing, mental & chemical health, legal services, youth programs, workshops and support groups."
  },
  {
    "Record ID": 182,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Safe Avenues",
    "Address": "1950 19th Ave. SW",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Willmar",
    "State": "MN",
    "Zip Code": 56201,
    "County": "Kandiyohi",
    "Main phone number": "320-235-0475",
    "Crisis Line Phone Number": "1-800-792-4210",
    "Organization website": "www.willmarshelter.com",
    "Organization Email": "",
    "Hours of operation": "Office Hours: Mon. - Fri.: 8:00 a.m. - 4:30 p.m. Shelter: 24 hours, 7 days a week",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Victim of violence.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Emergency safe shelter, advocacy, parenting support, safety planning."
  },
  {
    "Record ID": 183,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Minnesota Coalition for Battered Women (MCBW) changed name to:  Violence Free Minnesota",
    "Address": "60 East Plato Blvd",
    "Suite (Ste.) or Apartment (Apt.) number": "Suite 230",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55107,
    "County": "Ramsey",
    "Main phone number": "651-646-6177",
    "Crisis Line Phone Number": "1-866-223-1111",
    "Organization website": "www.vfmn.org",
    "Organization Email": "",
    "Hours of operation": "24/7 hotline, call for other service hours.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Spanish on site. Interpreter services for other languages  available upon request.",
    "Please provide a description of services your organization offers": "Economic and racial  justice advocacy, relationship abuse support, housing and disability rights advocacy, reproductive freedom support. Services throughout the state, go to website and choose county."
  },
  {
    "Record ID": 184,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Ramsey County Sexual Violence Services",
    "Address": "555 Cedar St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55104,
    "County": "Ramsey",
    "Main phone number": "",
    "Crisis Line Phone Number": "651-266-1000",
    "Organization website": "www.ramseyco.us",
    "Organization Email": "",
    "Hours of operation": "24/7",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Ramsey county residents.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "24-hour crisis counseling, advocacy and support during medical, police and legal procedures, counseling/support groups/safety planning. Referral for therapy, shelter and financial needs. Community education programs, prevention."
  },
  {
    "Record ID": 185,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Women’s Advocates",
    "Address": "PO Box 4039",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55104,
    "County": "Ramsey",
    "Main phone number": "651-227-9966",
    "Crisis Line Phone Number": "651-227-8284",
    "Organization website": "www.wadvocates.org",
    "Organization Email": "",
    "Hours of operation": "24/7",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Women and children",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Hotline, emercency shelter, safety after shelter, education and resources."
  },
  {
    "Record ID": 186,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Hope Center",
    "Address": "1003 7th St. NW",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Faribault",
    "State": "MN",
    "Zip Code": 55021,
    "County": "Rice",
    "Main phone number": "507-332-0882",
    "Crisis Line Phone Number": "1-800-607-2330",
    "Organization website": "hopecentermn.org",
    "Organization Email": "",
    "Hours of operation": "Crisis line 24/7",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Rice County residents",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Spanish on site. Interpreter services for other languages  available upon request.",
    "Please provide a description of services your organization offers": "Phone support, emergency shelter, counseling, support groups, hospital support, legal advocacy."
  },
  {
    "Record ID": 187,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Central Minnesota Sexual Assault Center",
    "Address": "15 Riverside Drive NE",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Cloud",
    "State": "MN",
    "Zip Code": 56304,
    "County": "Stearns",
    "Main phone number": "320-251-4357",
    "Crisis Line Phone Number": "",
    "Organization website": "www.cmsac.org",
    "Organization Email": "cmsac@cmsac.org",
    "Hours of operation": "Mon. - Fri.: 8:30 a.m. - 4:30 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Residents of Benton, Sherburne, Stearns, and Wright counties.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "24-Hour Crisis Phone Line, counseling, support groups, human trafficking services, support for sex workers, safety planning, legal & hospital advocacy , professional & community training/education, referrals."
  },
  {
    "Record ID": 188,
    "Type of Service": "Health Services",
    "Name of Organization": "Allina Clinic - Fridley",
    "Address": "500 Osborne Rd. NE",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 255",
    "City": "Fridley",
    "State": "MN",
    "Zip Code": 55432,
    "County": "Anoka",
    "Main phone number": "763-236-2500",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "Mon - Fri: 7:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Refugee health assessments, Primary Care, and specialty care either in clinic or through referral."
  },
  {
    "Record ID": 189,
    "Type of Service": "Health Services",
    "Name of Organization": "HealthPartners / Riverway Clinics -Anoka & Andover",
    "Address": "601 Jacob Lane",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Anoka",
    "State": "MN",
    "Zip Code": 55303,
    "County": "Anoka",
    "Main phone number": "763-587-4400",
    "Crisis Line Phone Number": "",
    "Organization website": "www.healthpartners.com",
    "Organization Email": "",
    "Hours of operation": "Mon. - Thurs. 7:30 a.m. - 5:00 p.m.  Urgent Care: Mon.-Fri. 8:00 a.m. - 8:00 p.m.  and Sat. - Sun. 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Family medicine, Pediatrics, Allergy, Chiropractic, Gastroenterology, IV therapy, Medication Therapy Management, Nutrition, OB-Gyn, Occupational Medicine, Podiatry."
  },
  {
    "Record ID": 190,
    "Type of Service": "Health Services",
    "Name of Organization": "Mercy Hospital - Allina",
    "Address": "4050 Coon Rapids Blvd.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Coon Rapids",
    "State": "MN",
    "Zip Code": 55433,
    "County": "Anoka",
    "Main phone number": "763-236-6000",
    "Crisis Line Phone Number": "",
    "Organization website": "www.alliahealth.org/mercy-hospital",
    "Organization Email": "",
    "Hours of operation": "24/7 days",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Comprehensive medical services including level 2 trauma center, acute care of the elderly, and bariatric weight loss services."
  },
  {
    "Record ID": 191,
    "Type of Service": "Health Services",
    "Name of Organization": "North Metro Pediatrics",
    "Address": "10081 Dogwood St.",
    "Suite (Ste.) or Apartment (Apt.) number": "Suite 100",
    "City": "Coon Rapids",
    "State": "MN",
    "Zip Code": 55448,
    "County": "Anoka",
    "Main phone number": "763-783-3722",
    "Crisis Line Phone Number": "",
    "Organization website": "www.northmetropeds.org",
    "Organization Email": "",
    "Hours of operation": "M, T, W, F: 9:00 a.m. - 4:30 p.m.   Th: 9:00 a.m. - 7:00 p.m.  Fri: 9:00 a.m. - 2:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Birth to 21 years old.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Primary care, Well baby checks and physicals, sick visits, mental/behavioral health, sports physicals, lactation consultation, and dental care."
  },
  {
    "Record ID": 192,
    "Type of Service": "Health Services",
    "Name of Organization": "Carver County Public Health",
    "Address": "602 E. Fourth St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Chaska",
    "State": "MN",
    "Zip Code": 55318,
    "County": "Carver",
    "Main phone number": "952-361-1600",
    "Crisis Line Phone Number": "",
    "Organization website": "www.co.carver.mn.us",
    "Organization Email": "",
    "Hours of operation": "Mon-Fri: 8:00 p.m. - 4:30 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Carver county residents",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants, some services free)",
    "Interpretation services": "Spanish on site. Interpreter services for other languages  available upon request.",
    "Please provide a description of services your organization offers": "Immunizations, refugee health screening referrals, tuberculosis case management, child and teen check-up services, family home visiting, women, infants, and children (WIC) program, health education."
  },
  {
    "Record ID": 193,
    "Type of Service": "Health Services",
    "Name of Organization": "Catalyst Medical Clinic",
    "Address": "204 Lewis Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 201",
    "City": "Watertown",
    "State": "MN",
    "Zip Code": 55388,
    "County": "Carver",
    "Main phone number": "952-955-1963",
    "Crisis Line Phone Number": "",
    "Organization website": "www.catalystmedicalclinic.com",
    "Organization Email": "",
    "Hours of operation": "Mon. & Wed.: 8:00 a.m. - 5:00 p.m.   Tues. & Thurs. 7:30 am - 5 Pm  Firday 8 am - 3 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Primary care, physical exams, acute illness and injury services, preventative medicine, mental health services, dermatology, patient education, outpatient surgical procedures, alternative medicine options."
  },
  {
    "Record ID": 194,
    "Type of Service": "Health Services",
    "Name of Organization": "River Valley Nursing Center",
    "Address": "303 East 6th St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Chaska",
    "State": "MN",
    "Zip Code": null,
    "County": "Carver",
    "Main phone number": "952-496-8669",
    "Crisis Line Phone Number": "",
    "Organization website": "www.rivervalleyhealthservices.org",
    "Organization Email": "",
    "Hours of operation": "Tues. 1:00 p.m. - 5:00 p.m. No appointment needed.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Carver and Scott county residents who are uninsured or under-insured.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Spanish on site. Interpreter services for other languages  available upon request.",
    "Please provide a description of services your organization offers": "Blood glucose screening, blood pressure checks, cholesterol screening,  health education, pregnancy verification for medical assistance, over-the-counter prescription assistance, MNsure eligibility assistance, case management."
  },
  {
    "Record ID": 195,
    "Type of Service": "Health Services",
    "Name of Organization": "River Valley Nursing Center",
    "Address": "752 Canterbury Road",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Shakopee",
    "State": "MN",
    "Zip Code": 55337,
    "County": "Dakota",
    "Main phone number": "952-496-8669",
    "Crisis Line Phone Number": "",
    "Organization website": "www.rivervalleyhealthservices.org",
    "Organization Email": "",
    "Hours of operation": "Mondays 2:00- 6:00 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Dakota county residents wo are uninsured or under-insured.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Spanish on site. Interpreter services for other languages  available upon request.",
    "Please provide a description of services your organization offers": "Blood glucose screening, blood pressure checks, cholesterol screening,  health education, pregnancy verification for medical assistance, over-the-counter prescription assistance, MNsure eligibility assistance, case management."
  },
  {
    "Record ID": 196,
    "Type of Service": "Health Services",
    "Name of Organization": "Allina Health Eagan Clinic",
    "Address": "1110 Yankee Doodle Rd.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Eagan",
    "State": "MN",
    "Zip Code": 55121,
    "County": "Dakota",
    "Main phone number": "651-454-3970",
    "Crisis Line Phone Number": "",
    "Organization website": "www.allinahealth.org",
    "Organization Email": "",
    "Hours of operation": "Mon., Wed., & Fri. 8 am - 5 pm  Tues. & Thurs. 8 am - 7 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Family practice, internal medicine, OB/GYN, ophtalmology, optometry, osteopathic medicine, pediatrics, podiatry, psychology (adult, child and teen), women's health, workers' comp. exam."
  },
  {
    "Record ID": 197,
    "Type of Service": "Health Services",
    "Name of Organization": "Dakota County Northern Service Center Courthouse",
    "Address": "1 Mendota Rd.",
    "Suite (Ste.) or Apartment (Apt.) number": "#100",
    "City": "West St. Paul",
    "State": "MN",
    "Zip Code": 55118,
    "County": "Dakota",
    "Main phone number": "651-554-6100",
    "Crisis Line Phone Number": "952-891-7171",
    "Organization website": "www.co.dakota.mn.us",
    "Organization Email": "public.health@co.dakota.mn.us",
    "Hours of operation": "Mon. - Fri.: 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Dakota county residents.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Financial assistance (Sliding fee scale, discounted rate, grants, some services free)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "WIC, child and teen checkups, immunization clinics, TB and refugee health follow-up, family home visits, dental services, TB testing and treatment, STD testing, asthma consultations, and referrals."
  },
  {
    "Record ID": 198,
    "Type of Service": "Health Services",
    "Name of Organization": "Dakota County Public Health Western Service Center",
    "Address": "14955 Galaxie Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Apple Valley",
    "State": "MN",
    "Zip Code": 55124,
    "County": "Dakota",
    "Main phone number": "952-891-6100",
    "Crisis Line Phone Number": "",
    "Organization website": "www.co.dakota.mn.us",
    "Organization Email": "public.health@co.dakota.mn.us",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Dakota county residents.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Financial assistance (Sliding fee scale, discounted rate, grants, some services free)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "WIC, child and teen checkups, immunization clinics, TB and refugee health follow-up, family home visits, dental services, TB testing and treatment, STD testing, asthma consultations, and referrals."
  },
  {
    "Record ID": 199,
    "Type of Service": "Health Services",
    "Name of Organization": "Diamondhead Clinic",
    "Address": "200 W. Burnsville Parkway",
    "Suite (Ste.) or Apartment (Apt.) number": "Lower Level of Diamondhead Education Center",
    "City": "Burnsville",
    "State": "MN",
    "Zip Code": 55337,
    "County": "Dakota",
    "Main phone number": "952-707-4171",
    "Crisis Line Phone Number": "",
    "Organization website": "www.co.dakota.mn.us",
    "Organization Email": "",
    "Hours of operation": "Tues. &. Thurs. 1:00 - 4:30 p.m. Walk-in clinic. No appointment necessary.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Ages 0-21 if living in Burnsville, Eagan, Savage, or ISD 191 school district. 18-21 must be enrolled in ISD 191.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Somali and Spanish on site. Interpreter services for other languages available upon request.",
    "Please provide a description of services your organization offers": "Non-emergency medical care: immunizations, sports physicals, health education, treatment of minor medical conditions,  mental health.Nutrition, physical activity, sexual health, and tobacco counseling."
  },
  {
    "Record ID": 200,
    "Type of Service": "Health Services",
    "Name of Organization": "FamilyHealth Medical Clinic - Lakeville",
    "Address": "9974 214th Street West",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Lakeville",
    "State": "MN",
    "Zip Code": 55044,
    "County": "Dakota",
    "Main phone number": "952-469-0500",
    "Crisis Line Phone Number": "",
    "Organization website": "www.northfieldhospital.org/lakeville-clinic",
    "Organization Email": "",
    "Hours of operation": "Mon - Fri: 8 a.m. to 5 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Family medicine, birth center, cancer center, pediatrics,  OB/GYN, ear, nose and throat, orthopedics/sports medicine, surgery, urgent care, specialty referrals."
  },
  {
    "Record ID": 201,
    "Type of Service": "Health Services",
    "Name of Organization": "FamilyHealth Medical Clinic– Farmington",
    "Address": "4645 Knutsen Drive",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Farmington",
    "State": "MN",
    "Zip Code": 55024,
    "County": "Dakota",
    "Main phone number": "651-460-2300",
    "Crisis Line Phone Number": "",
    "Organization website": "www.northfieldhocpital.org/farmington-clinic",
    "Organization Email": "",
    "Hours of operation": "Mon - Fri: 7:30 a.m. to 5 p.m",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Family medicine, birth center, cancer center, pediatrics,  OB/GYN, ear, nose and throat, orthopedics/sports medicine, surgery, urgent care, specialty referrals."
  },
  {
    "Record ID": 202,
    "Type of Service": "Health Services",
    "Name of Organization": "St. Mary’s Health Clinics",
    "Address": "Various locations throughout the Twin Cities metro area including: Apple Valley",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "",
    "State": "MN",
    "Zip Code": null,
    "County": "Dakota",
    "Main phone number": "651-287-7777",
    "Crisis Line Phone Number": "",
    "Organization website": "www.stmaryshealthclinics.org",
    "Organization Email": "info@stmarysclinics.org",
    "Hours of operation": ". Scheduling times: Mon. - Thurs. 8:30 a.m. - 3:30 p.m. Fri. 8:30 a.m. - 12:30 p.m. Call scheduling number for more specific site information. No Walk-ins.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Must be without health insurance. Call scheduling number for brief, telephone eligibility screening.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Spanish interpreters on site. Ask about interpreter services when scheduling.",
    "Please provide a description of services your organization offers": "Primary care, specialty & hospital referrals, most medications. Culturally Specific Services: Diabetes education in Spanish and English. Provide assistance with applications for MN health care programs."
  },
  {
    "Record ID": 203,
    "Type of Service": "Health Services",
    "Name of Organization": "Women's Health Center of Northfield",
    "Address": "2000 North Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Northfield",
    "State": "MN",
    "Zip Code": 55057,
    "County": "Dakota",
    "Main phone number": "507-646-1478",
    "Crisis Line Phone Number": "",
    "Organization website": "www.northfieldhospital.org",
    "Organization Email": "",
    "Hours of operation": "Mon. & Tues. 8 am - 8 pm  Wed. & Fri. 8:00 a.m. - 4:30 p.m.  Thurs. 8 am - 7 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Women and girls any age.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Clinic specializes in services for women: birth center, cancer care, ENT, family medicine, orthopedics, pediatrics, pregnancy care, OB/GYN, midwife, surgery"
  },
  {
    "Record ID": 204,
    "Type of Service": "Health Services",
    "Name of Organization": "Planned Parenthood of MN/SD/ND",
    "Address": "15322 Galaxie Avenue",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 105",
    "City": "Apple Valley",
    "State": "MN",
    "Zip Code": 55124,
    "County": "Dakota",
    "Main phone number": "952-890-0940",
    "Crisis Line Phone Number": "",
    "Organization website": "www.plannedparenthood.org",
    "Organization Email": "",
    "Hours of operation": "Mon., Wed. & Fri.: 9:00 a.m. - 5:00pm.   Tues.&Thurs.: 10:00 a.m. - 6:00 p.m.  Sat. 10:00 a.m. - 2:00 p.m.  Book apt. online or call. Walk-ins anytime for morning after pill & birth control refills. Pregnancy & HIV rapid test walk-in 1 hr. prior to close.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants, some services free)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Sex edutation, family planning, birth control, HIV testing, LGBTQAI+ services, morning-after pill (emergency contraception), pregnancy testing & services, STD testing, treatment & vaccines, womesn's health,  men's health."
  },
  {
    "Record ID": 205,
    "Type of Service": "Health Services",
    "Name of Organization": "Women, Infants, and Children (WIC) Dakota County Public Health",
    "Address": "14955 Galaxie Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Apple Valley",
    "State": "MN",
    "Zip Code": 55124,
    "County": "Dakota",
    "Main phone number": "952-891-7525",
    "Crisis Line Phone Number": "",
    "Organization website": "www.co.dakota.mn.us",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. - 5:00 p.m. and some evenings.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Women who are pregnant, breastfeeding or families with a child under age 5.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Nutrition advice, access to healthy foods, special couseling for pregnant and breasfeeding mothers, referrals to health care."
  },
  {
    "Record ID": 206,
    "Type of Service": "Health Services",
    "Name of Organization": "Annex Teen Clinic",
    "Address": "5810 42nd Ave. N.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Robbinsdale",
    "State": "MN",
    "Zip Code": 55422,
    "County": "Hennepin",
    "Main phone number": "763-533-1316",
    "Crisis Line Phone Number": "",
    "Organization website": "www.annexteenclinic.org",
    "Organization Email": "andre@annexteenclinic.org",
    "Hours of operation": "Mon., Tues. & Thurs. 10 am - 7 pm  (2nd & 4th Mondays, open at noon)  Wed. & Fri., 10 am - 5 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Adolescents and young adults through age 25.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Financial assistance (Sliding fee scale, discounted rate, grants)  Free",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Sexual health: birth control, condoms, spermicides, emergency contraception, pregnancy testing, all options counseling, STD & HIV/AIDS testing and treatment, risk assessment and risk reduction information, vaginal infection treatment."
  },
  {
    "Record ID": 207,
    "Type of Service": "Health Services",
    "Name of Organization": "Broadway Family Medicine University of MN Physicians",
    "Address": "1020 W. Broadway",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55411,
    "County": "Hennepin",
    "Main phone number": "612-302-8200",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "Mon.- Fri.: 8:00 a.m. - 5:00pm.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Primary care, pediatrics, well-child care, vaccinations, physicals, geriatric care, pregnancy and women's health, osteopathic therapy, link to social services, patient education, referrals to specialty care."
  },
  {
    "Record ID": 208,
    "Type of Service": "Health Services",
    "Name of Organization": "Cedar Riverside People’s Center Clinic",
    "Address": "425 20th Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55454,
    "County": "Hennepin",
    "Main phone number": "612-332-4973",
    "Crisis Line Phone Number": "",
    "Organization website": "www.peoples-center.org",
    "Organization Email": "",
    "Hours of operation": "Mon. & Fri. 8:30 am - 5 pm  Tues., Wed., and Thurs., 8:30 am - 8 pm  Sat. 9 am - 1 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance  Public insurance (MA, MNCare)  Financial assistance (Sliding fee scale, discounted rate, grants)  Free",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Primary care, pediatrics, geriatrics, women's health, vaccines, well-child visits, physicals, birth control, STD/HIV testing, sexual health, chronic disease, physical therapy, behavioral health, substance use, case maangement and referrals."
  },
  {
    "Record ID": 209,
    "Type of Service": "Health Services",
    "Name of Organization": "Central Clinic",
    "Address": "2301 Central Ave. NE",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55418,
    "County": "Hennepin",
    "Main phone number": "612-588-9411",
    "Crisis Line Phone Number": "612-588-9411",
    "Organization website": "www.neighborhoodhealthsource.org",
    "Organization Email": "",
    "Hours of operation": "Mon., Tues. & Thurs. 8 am - 5 pm  Wed., 8 am to 7 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Primaryc care, physicals, immunizations, nutrition, sexual health, womens health, pediatrics, ADHD,  behavioral health, substance abuse treatment, chronic disease management.  After hours phone consultation."
  },
  {
    "Record ID": 210,
    "Type of Service": "Health Services",
    "Name of Organization": "Children’s Specialty Center",
    "Address": "2530 Chicago Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55404,
    "County": "Hennepin",
    "Main phone number": "612-813-6000",
    "Crisis Line Phone Number": "",
    "Organization website": "www.childrensmn.org",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Birth to 18 years old.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Primary and Specialty care - including disabilities experienced by children. Most specialty referrals must be made by a primary care provider."
  },
  {
    "Record ID": 211,
    "Type of Service": "Health Services",
    "Name of Organization": "Children's Hospitals and Clinics of MN",
    "Address": "2525 Chicago Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55404,
    "County": "Hennepin",
    "Main phone number": "612-813-6000",
    "Crisis Line Phone Number": "",
    "Organization website": "www.childrensmn.org",
    "Organization Email": "",
    "Hours of operation": "Specialty scheduler Mpls.: 612-813- 8431",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Birth to 18 years old. Most specialty referrals must go through primary care.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Primary Care, acute care, surgery, Level I pediatric trauma and emergency care. Team approach for specialty care where Clinicians and Social workers assigned to cases. Referrals: 612-343-2121; Heart Clinic - Mpls: 612-813-8800; St. Paul: 651-220-8800. Oncology - Mpls.:612-813-5940; St. Paul 651-220-6000."
  },
  {
    "Record ID": 212,
    "Type of Service": "Health Services",
    "Name of Organization": "Community University Health Care Center (CUHCC)",
    "Address": "2001 Bloomington Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55404,
    "County": "Hennepin",
    "Main phone number": "612-301-3433",
    "Crisis Line Phone Number": "",
    "Organization website": "www.cuhcc.umn.edu",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 7:15 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants, some services free)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Primary & acute care, prenatal care, well-child care, family planning, chronic disease management, physicals, mental health. Focus on culturally sensitive care.  Assistance with legal services, victim advocacy, and care coordination."
  },
  {
    "Record ID": 213,
    "Type of Service": "Health Services",
    "Name of Organization": "Park Nicollet Clinic - Creekside",
    "Address": "6600 Excelsior Blvd.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Louis Park",
    "State": "MN",
    "Zip Code": 55426,
    "County": "Hennepin",
    "Main phone number": "952-993-7700",
    "Crisis Line Phone Number": "",
    "Organization website": "www.healthpartners.com",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Primary care, internal medicine, mental/chemical healthe, oncology & hematology, radiology."
  },
  {
    "Record ID": 214,
    "Type of Service": "Health Services",
    "Name of Organization": "Crown Medical Center",
    "Address": "7001 78th Ave. N.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Brooklyn Park",
    "State": "MN",
    "Zip Code": 55445,
    "County": "Hennepin",
    "Main phone number": "763-566-4535",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 9:00 a.m. - 5:00 p.m. Walk ins accepted. Saturday: by appointment only",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Primary & acute care, immigration exam, HIV screening, labratory, immunization travel clinic. Culturally Specific Services: Outreach diabetes education for Africans/African American; preventative HIV education and testing."
  },
  {
    "Record ID": 215,
    "Type of Service": "Health Services",
    "Name of Organization": "Crown Medical Center",
    "Address": "1925 First Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55403,
    "County": "Hennepin",
    "Main phone number": "612-871-4354",
    "Crisis Line Phone Number": "",
    "Organization website": "www.crownmedicalcenter.org",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri.: 9:00 a.m. - 5:00 p.m. Sat: 10:00 a.m. - 2:00 p.m. Walk ins accepted Mon. - Sat.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Primary & Acute care, immigration exam, HIV screening, labratory, immunization travel clinic. Culturally Specific Services: Outreach diabetes education for Africans/African American; preventative HIV education and testing."
  },
  {
    "Record ID": 216,
    "Type of Service": "Health Services",
    "Name of Organization": "M Health Fairview Clinic - Lake Street",
    "Address": "1527 E. Lake Street",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 150",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55407,
    "County": "Hennepin",
    "Main phone number": "612-721-6511",
    "Crisis Line Phone Number": "",
    "Organization website": "www.fairview.org",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 7:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Family medicine, internal medicine, mammography, X-ray and Imaging, anticoagulation.  24/7 consultation, diagnosis, and treatment for many conditions through \"oncare\" online portal for $45, but may be covered by insurance."
  },
  {
    "Record ID": 217,
    "Type of Service": "Health Services",
    "Name of Organization": "Fremont Clinic - Neighborhood Healthsource",
    "Address": "3300 Fremont Ave N.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55412,
    "County": "Hennepin",
    "Main phone number": "612-588-9411",
    "Crisis Line Phone Number": "612-588-9411",
    "Organization website": "www.neighborhoodhealthsource.org",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Primary care, physicals,  immunizaitons & flu shots, nutrition, sexual health, womens health, STI & HIV testing & treatment, pediatric &  adolescent care, minor surgeries, chronic disease management."
  },
  {
    "Record ID": 218,
    "Type of Service": "Health Services",
    "Name of Organization": "Hennepin Healthcare - Brooklyn Park Clinic & Pharmacy",
    "Address": "7650 Zane Ave. North",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Brooklyn Park",
    "State": "MN",
    "Zip Code": 55443,
    "County": "Hennepin",
    "Main phone number": "612-873-6963",
    "Crisis Line Phone Number": "",
    "Organization website": "www.hennepinhealthcare.org",
    "Organization Email": "",
    "Hours of operation": "Mon. - Thurs. 7:30 am - 7:30 pm  Fri. 8:00 a.m. - 5:00 p.m.  Sat. Acute Care Walk-ins 8 am - Noon",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Primary, specialty, & urgent care, imaging/radiology, lab, pharmacy, behavioral health, women's health, nurse-midwives, pediatrics, geratrics, cardiology, rheumatology, podiatry, diabetes,  acupuncutre, chiropractic, physical & occupational therapy, orthopedics, surgery consults ."
  },
  {
    "Record ID": 219,
    "Type of Service": "Health Services",
    "Name of Organization": "Hennepin Healthcare - Richfield Clinic & Pharmacy",
    "Address": "790 West 66th St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Richfield",
    "State": "MN",
    "Zip Code": 55423,
    "County": "Hennepin",
    "Main phone number": "612-873-6963",
    "Crisis Line Phone Number": "",
    "Organization website": "www.hennepinhealthcare.org",
    "Organization Email": "",
    "Hours of operation": "Mon., Wed. &  Thurs. 8:00 a.m. - 8:00 p.m.  Tues. & Fri. 8:00 a.m. - 5:00 p.m.  Sat. 8:30 am - noon",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Primary, specialty, & urgent care, imaging/radiology, lab, pharmacy, behavioral health, women's health, nurse-midwives, pediatrics, geratrics, cardiology, rheumatology, podiatry, diabetes,  acupuncutre, chiropractic, physical & occupational therapy, orthopedics, surgery consults ."
  },
  {
    "Record ID": 220,
    "Type of Service": "Health Services",
    "Name of Organization": "Hennepin Healthcare Whittier Clinic & Pharmacy",
    "Address": "2810 Nicollet Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55408,
    "County": "Hennepin",
    "Main phone number": "612-873-6963",
    "Crisis Line Phone Number": "",
    "Organization website": "www.hennepinhealthcare.org",
    "Organization Email": "",
    "Hours of operation": "Mon. - Thurs. 8:00 a.m. - 8:30 p.m.   Fri. 8:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Primary, specialty, & urgent care, imaging/radiology, lab, pharmacy, behavioral health, women's health, nurse-midwives, pediatrics, geratrics, cardiology, rheumatology, podiatry, diabetes,  acupuncutre, chiropractic, physical & occupational therapy, orthopedics, surgery consults ."
  },
  {
    "Record ID": 221,
    "Type of Service": "Health Services",
    "Name of Organization": "Hennepin Healthcare Clinic and Specialty Center",
    "Address": "715 South 8th Street",
    "Suite (Ste.) or Apartment (Apt.) number": "Level 2",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55404,
    "County": "Hennepin",
    "Main phone number": "612-873-6963",
    "Crisis Line Phone Number": "",
    "Organization website": "www.hennepinhealthcare.org",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8 am - 6 pm  Sat. 9 am - 4:30 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Primary Care, Comprehensive Specialty care, Urgent Care, Community Care, Imaging/Radiology, Lab services, Pharmacy, and this location brings together 26 primary and specialty care clinics under one roof."
  },
  {
    "Record ID": 222,
    "Type of Service": "Health Services",
    "Name of Organization": "Hennepin County Public Health Clinic",
    "Address": "525 Portland Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "4th floor",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55415,
    "County": "Hennepin",
    "Main phone number": "612 543-5555",
    "Crisis Line Phone Number": "",
    "Organization website": "www.hennepin.us/residents/health-medical/clinic-services",
    "Organization Email": "",
    "Hours of operation": "Mon., Wed. 8:00 a.m. - 7:00 p.m.   Tues. & Fri. 8:00 a.m. - 4:00 p.m.  Thurs. 10 am - 4 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Residents of Hennepin County",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants, some services free)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Refugee health screening, Immigration exams, , Tuberculosis control services, Testing and treatment for sexually transmitted diseases, HIV testing, and family planning services."
  },
  {
    "Record ID": 223,
    "Type of Service": "Health Services",
    "Name of Organization": "Indian Health Board of Minneapolis Inc.",
    "Address": "1315 East 24th St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55404,
    "County": "Hennepin",
    "Main phone number": "612-721-9800",
    "Crisis Line Phone Number": "",
    "Organization website": "www.indianhealthboard.com",
    "Organization Email": "",
    "Hours of operation": "Mon., Wed., Thurs. & Fri. 8:00 a.m. - 5:00 p.m.   Tues. 8:00 a.m. - 8:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare), Financial assistance (Sliding fee scale, discounted rate, grants, some services free)",
    "Interpretation services": "Spanish available by appointment.",
    "Please provide a description of services your organization offers": "Primary care, dental, mental health, wellness & prevention, traditional medicines, and cultural practices. Focus on American Indian and Alaska Native traditions and identity, all people are welcome."
  },
  {
    "Record ID": 224,
    "Type of Service": "Health Services",
    "Name of Organization": "Life Medical, P.A.",
    "Address": "4201 Excelsior Blvd.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Louis Park",
    "State": "MN",
    "Zip Code": 55416,
    "County": "Hennepin",
    "Main phone number": "952-933-8900",
    "Crisis Line Phone Number": "",
    "Organization website": "www.lifemedical.us",
    "Organization Email": "",
    "Hours of operation": "Mon. -thurs. 9:00 a.m. - 6:00 p.m.  Fri 9 am - 5 pm  Sat. Chiropractic services 9 am - 2 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare)",
    "Interpretation services": "Russian, Ukrainian on site. Interpreter services for other languages upon request.",
    "Please provide a description of services your organization offers": "Primary care, PTSD Treatment, Mental health, Weight mgmt. & Nutrition, Chiropractic, Physical Therapy, Lasar therapy, Disability Determination, Personal Injury, Immigration exams, and Integrative medicine including Acupuncture, Herbal Medicine, Homeopathy, Neuroresearch Protocol, Naturopathic Medicine, and Medical/Legal advocacy."
  },
  {
    "Record ID": 225,
    "Type of Service": "Health Services",
    "Name of Organization": "Lions Children's Hearing and Ear, Nose, and Throat Clinic",
    "Address": "701 25th Ave. S.",
    "Suite (Ste.) or Apartment (Apt.) number": "Park Plaza Building, 2nd Floor",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55454,
    "County": "Hennepin",
    "Main phone number": "612-365-8300",
    "Crisis Line Phone Number": "",
    "Organization website": "www.mhealth.org",
    "Organization Email": "",
    "Hours of operation": "Mon. - Fri. 8:00 am - 5:00 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Children from birth to 18.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Employer-based/Private insurance, Public insurance (MA, MNCare)",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Audiology, assessment of hearing loss in children, rehabilitation, ENT physicians, genetic counseling, infectious disease, and pediatric neuropsychology. Referrals to community resources for children with hearing loss and their families."
  },
  {
    "Record ID": 226,
    "Type of Service": "Health Services",
    "Name of Organization": "JustUs Health",
    "Address": "2577 West Territorial Road",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55114,
    "County": "Ramsey",
    "Main phone number": "612-341-2060",
    "Crisis Line Phone Number": "612-373-2437 or 1-800-248-2437 or text 'AIDSLine to 839636",
    "Organization website": "www.justushealth.org",
    "Organization Email": "info@justushealth.org",
    "Hours of operation": "Mon. - Fri. 9:00 a.m. - 5:00 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Serves those at risk of and living with HIV, breaks barriers due to gender identity or race. Case management, tesing, syringe exchange, advocacy, legal services, housing, behavioral health, support groups."
  },
  {
    "Record ID": 227,
    "Type of Service": "Health Services",
    "Name of Organization": "JustUs Health - Mainline syringe exchange",
    "Address": "3100 Park Ave.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55407,
    "County": "Hennepin",
    "Main phone number": "612-341-2060",
    "Crisis Line Phone Number": "",
    "Organization website": "www.justushealth.org",
    "Organization Email": "info@justushealth.org",
    "Hours of operation": "Mon. & Thurs.: 2-5 pm  Tues. & Fri.: 10 am - 1 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Free",
    "Interpretation services": "Interpreter services available upon request.",
    "Please provide a description of services your organization offers": "Syringe exchnage, Education, and HIV prevention and Care services, and provide Naloxone during all regular Mainline hours. Referral to other services as needed."
  },
  {
    "Record ID": 228,
    "Type of Service": "Health Services",
    "Name of Organization": "Minnesota Community Acupuncture",
    "Address": "4455 Highway 169 N.",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 201",
    "City": "Plymouth",
    "State": "MN",
    "Zip Code": 55442,
    "County": "Hennepin",
    "Main phone number": "952-746-3478",
    "Crisis Line Phone Number": "",
    "Organization website": "www.minnca.com",
    "Organization Email": "reception@minnca.com",
    "Hours of operation": "Mon & Wed.: 9:30 am – 6:00 pm  Tues. & Thurs: 10:00 am - 6:30 pm  Sat.: 10:30 a.m. - 3:30 p.m.",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "$25 for initial treatment.  $20 - $40 sliding scale for additional visits.  $10 Acupressure for children from birth - 12 y.o.  Accept Health Savings Account and Flex Savings cards.",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Acupuncture, Acupressure, and Cupping."
  },
  {
    "Record ID": 229,
    "Type of Service": "Health Services",
    "Name of Organization": "Minneapolis Community Acupuncture",
    "Address": "3707 E. 42nd St.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55406,
    "County": "Hennepin",
    "Main phone number": "612-708-8917",
    "Crisis Line Phone Number": "",
    "Organization website": "www.mplsacu.com",
    "Organization Email": "clinic@mplsacu.com",
    "Hours of operation": "Tues., Thurs. & Fri. 9 am - 1 pm  Mon., Wed. & Thurs.,  3 pm - 6 pm  Sun., 11 am - 4 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "$20-$45 Sliding scale; $10 additional one-time charge at first visit.",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Acupuncture."
  },
  {
    "Record ID": 230,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Shifa Metro Clinic",
    "Address": "5270 W 84th St ",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste. 370",
    "City": "Bloomington",
    "State": "MN",
    "Zip Code": 55437,
    "County": "Hennepin",
    "Main phone number": "(952) 395-5222",
    "Crisis Line Phone Number": "",
    "Organization website": "https://shifametroclinic.com/",
    "Organization Email": "appointments@shifametroclinic.com",
    "Hours of operation": "Monday-Friday 10 am-6 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "MA/PMAP, Blue Cross Blue Shield / Companion Benefits Alternative, Medicare Part B, Cigna, United Health / Optum, Aetna",
    "Interpretation services": "Providers speak Swahili, English, Somali, Arabic, & Oromo.",
    "Please provide a description of services your organization offers": "Offering psychiatric evaluations, medication management, clinical social work, and therapy."
  },
  {
    "Record ID": 231,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "The Family Partnership",
    "Address": "1527 East Lake Street",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "MINNEAPOLIS",
    "State": "MN",
    "Zip Code": null,
    "County": "Hennepin",
    "Main phone number": "(612) 728-2061",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.thefamilypartnership.org/",
    "Organization Email": "communication@thefamilypartnership.org",
    "Hours of operation": "Monday-Thursday: 9 am - 7 pm; Friday: 9 am - 5 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "multiple locations in the metro area",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "multilingual staff, interpreters available.",
    "Please provide a description of services your organization offers": "Holistic approach including mental health therapy, early childhood education and care, family home visiting and advocacy services for individuals and families."
  },
  {
    "Record ID": 232,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Minnesota Trauma Recovery Institute (MN-TRI)",
    "Address": "822 S. 3rd Street",
    "Suite (Ste.) or Apartment (Apt.) number": " Ste 100",
    "City": "MINNEAPOLIS",
    "State": "MN",
    "Zip Code": 55415,
    "County": "Hennepin",
    "Main phone number": "(612) 217-1667",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.mntri.org/mental-health-services",
    "Organization Email": "info@mntri.org",
    "Hours of operation": "",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Blue Cross Blue Shield, Medicaid, UCare, Hennepin Health, Health Partners, private pay/cash, sliding scale fee",
    "Interpretation services": "",
    "Please provide a description of services your organization offers": "Individual therapy for people with Trauma/PTSD, depression, anxiety, substance abuse/addiction"
  },
  {
    "Record ID": 233,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Family Circle Counseling",
    "Address": "2356 University Ave W",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste 280",
    "City": "Saint Paul",
    "State": "MN",
    "Zip Code": 55114,
    "County": "Ramsey",
    "Main phone number": "(651) 646-1488",
    "Crisis Line Phone Number": "",
    "Organization website": "https://fcircle.org/",
    "Organization Email": "",
    "Hours of operation": "Monday- Friday: 9 am - 8 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Blue Cross/Blue Shield, HealthPartners, Medica, UCare, Preferred One, Aetna, Medical Assistance, Medicare (select providers)    ",
    "Interpretation services": "Interpreters available upon request",
    "Please provide a description of services your organization offers": "Parent-child, complex children's behavioral health, family counseling, mood disorders (depression, anxiety, and bipolar disorder)."
  },
  {
    "Record ID": 234,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Hamm Clinic",
    "Address": "408 St. Peter Street",
    "Suite (Ste.) or Apartment (Apt.) number": "Ste 429",
    "City": "Saint Paul",
    "State": "MN",
    "Zip Code": 55102,
    "County": "Ramsey",
    "Main phone number": "(651) 224-0614",
    "Crisis Line Phone Number": "",
    "Organization website": "https://hammclinic.org/mental-health/therapy/",
    "Organization Email": "info@hammclinic.org",
    "Hours of operation": "Mon-Tues: 8 am - 8 pm; Wed - Thur: 8 am - 6 pm; Fri: 8 am - 5 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Adults",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Accepts all most health insurance plans, Medicaid and Medicare, sliding scale fee (copays and slide scale payments due at time of visit).",
    "Interpretation services": "Interpreters available upon request.",
    "Please provide a description of services your organization offers": "Culturally-response, integrative mental health care for individuals, couples/family, group therapy. Psychiatric evaluations, diagnoses and management for depression, anxiety, ADHD, trauma, schizophrenia, bipolar disorder and personality disorders."
  },
  {
    "Record ID": 235,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Center for Victims of Torture",
    "Address": "649 Dayton Avenue",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Saint Paul",
    "State": "MN",
    "Zip Code": 55104,
    "County": "Ramsey",
    "Main phone number": "(612) 436-4840",
    "Crisis Line Phone Number": "",
    "Organization website": "https://www.cvt.org/where-we-work/minnesota",
    "Organization Email": "",
    "Hours of operation": "",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Torture survivors",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "insurance, Medicaid, Refugee Medical Assistance.",
    "Interpretation services": "Interpreters available upon request.",
    "Please provide a description of services your organization offers": "Out-patient care, medical and nursing care, psychotherapy, social services and massage and physical therapy. Telehealth services available."
  },
  {
    "Record ID": 236,
    "Type of Service": "Mental Health Services",
    "Name of Organization": "Center for Victims of Torture",
    "Address": "",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Saint Cloud",
    "State": "MN",
    "Zip Code": null,
    "County": "Stearns",
    "Main phone number": "(320) 217-5052",
    "Crisis Line Phone Number": "",
    "Organization website": "",
    "Organization Email": "",
    "Hours of operation": "Monday - Friday: 9 am - 5 pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "War- trauma survivors, Refugees and asylum-seekers in the Saint Cloud area",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "",
    "Interpretation services": "Interpreters available upon request",
    "Please provide a description of services your organization offers": "Culturally competent rehabilitative care  incorporating culturally competent specialized care effective for survivors of war atrocities. Parenting classes, Telehealth available."
  },
  {
    "Record ID": 237,
    "Type of Service": "Domestic Violence Services and Sexual Assault Services",
    "Name of Organization": "Missions Inc. Programs",
    "Address": "3409 E. Medicine Lake Blvd.",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Plymouth",
    "State": "MN",
    "Zip Code": 55441,
    "County": "Hennepin",
    "Main phone number": "(763) 559-1883",
    "Crisis Line Phone Number": "7635594945",
    "Organization website": "www.missionsinc.org",
    "Organization Email": "info@missionsinc.org",
    "Hours of operation": "Monday-Friday: 7:30-3:30; 24/7 crisis line",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Individuals and families who have been impacted by domestic violence in Northwestern Hennepin County.  ",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "All services are provided free of charge.",
    "Interpretation services": "We use contracted interpretation services as needed.",
    "Please provide a description of services your organization offers": "Emergency shelter; safety planning; assistance with Orders for Protection or Harassment Restraining Orders; systems advocacy; legal advocacy; crisis support; advocacy with employers, landlords, etc.; direct financial assistance. Specialized services for immigrants and refugees experiencing domestic violence."
  },
  {
    "Record ID": 238,
    "Type of Service": "Health Services",
    "Name of Organization": "Axis Medical Center",
    "Address": "1801 Nicollet Ave S",
    "Suite (Ste.) or Apartment (Apt.) number": "101",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55403,
    "County": "Hennepin",
    "Main phone number": "(612) 823-2947",
    "Crisis Line Phone Number": "",
    "Organization website": "www.axismedicalcenter.org",
    "Organization Email": "info@axismedicalcenter.org",
    "Hours of operation": "Monday & Friday 8:00am-5:00pm, Tuesday & Thursday 8:00am-6:00pm, Saturday 9:00am-5:00pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Axis Medical Center provides health services to all individuals regardless of ability to pay. Dedicated to its responsibility as a foundational community service institution, Axis partners with area organizations to meet health care and wellness needs of underserved people, including immigrants, homeless, destitute, disabled, and uninsured. Axis educates and empowers people to achieve life-long agency and autonomy in their health and wellness.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "We take all insurances and have a sliding fee scale for those without insurance. We accept cash and credit card payments.",
    "Interpretation services": "We speak English, Somali, Hmong, Oromo, Amharic and Kiswahili.",
    "Please provide a description of services your organization offers": "Specialties we have:          - Internal Medicine          - Geriatrics          - Family Medicine          - Endocrinologist          - Asthma and Allergies          - Civil Surgeon          - Women's Health and       Family Planning    Medical services we offer:          - Primary Care          - Child and Teen       Check-ups          - Lab testing          - X-ray          - Immigration Exams          - Travel shots/         vaccinations    Health screens we offer:          - Cholesterol          - Blood sugar          - Blood pressure          - Colorectal screen"
  },
  {
    "Record ID": 239,
    "Type of Service": "Health Services",
    "Name of Organization": "Cham Clinic",
    "Address": "7362 University Ave NE ",
    "Suite (Ste.) or Apartment (Apt.) number": "206",
    "City": "Fridley",
    "State": "MN",
    "Zip Code": 55432,
    "County": "Anoka",
    "Main phone number": "(763) 657-0569",
    "Crisis Line Phone Number": "",
    "Organization website": "chamclinic.org",
    "Organization Email": "info@chamclinic.org",
    "Hours of operation": "9:00am-5:00pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "We take all ages and accept all patients. ",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "We accept UCare, Medica, Medicaid and in the process of waiting for other insurance to be approved. ",
    "Interpretation services": "We have contracts with many language services.",
    "Please provide a description of services your organization offers": "We provide primary care, refugee screening, walk-ins, and holistic care. "
  },
  {
    "Record ID": 240,
    "Type of Service": "Health Services",
    "Name of Organization": "Dakota Child and Family Clinic",
    "Address": "2530 Horizon Drive",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Burnsville",
    "State": "MN",
    "Zip Code": 55337,
    "County": "Dakota",
    "Main phone number": "(651) 209-8640",
    "Crisis Line Phone Number": "",
    "Organization website": "www.dakotachildandfamilyclinic.org",
    "Organization Email": "",
    "Hours of operation": "Monday-Thursday 8:00am-5:00pm, Friday 8:00am-12:00pm, Saturday 9:00am-3:00pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Unable to do immigration physicals.",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "Most insurance accepted, sliding scale fee ",
    "Interpretation services": "Contract with interpretation service for patients when needed.  Spanish, Hmong and Somali speaking staff.",
    "Please provide a description of services your organization offers": "Primary care & behavioral health for adults & children, adult mental health, pediatric gender care."
  },
  {
    "Record ID": 241,
    "Type of Service": "Health Services",
    "Name of Organization": "Evergreen Primary Care",
    "Address": "570 N Asbury St",
    "Suite (Ste.) or Apartment (Apt.) number": "208",
    "City": "St. Paul",
    "State": "MN",
    "Zip Code": 55104,
    "County": "Ramsey",
    "Main phone number": "(651) 376-3484",
    "Crisis Line Phone Number": "",
    "Organization website": "epcmn.org",
    "Organization Email": "",
    "Hours of operation": "Monday-Friday 9:00am-5:00pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "primary care services for ages 12+; green card medical exam; citizenship waivers",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "We do not take insurance for any work that we do. Instead our patients pay us directly a monthly flat fee for unlimited primary care services-no copays are collected. For any lab that is incurred, we have a cheap wholesale discount that on average costs $5 a test. ",
    "Interpretation services": "Dr Vang speaks Hmong.",
    "Please provide a description of services your organization offers": "Primary care services for those ages 12 y.o and above. Minor in-office procedures included in the monthly flat medical services fee. Unlimited office, virtual visits. Same/day next day appointments are possible for acute issues. Patients get to access their doctor directly. Dr Vang also conducts medical examination for green card and citizenship waivers. Contact her for more information or go to the website epcmn.org"
  },
  {
    "Record ID": 242,
    "Type of Service": "Health Services",
    "Name of Organization": "Open Arms",
    "Address": "2500 Bloomington Ave",
    "Suite (Ste.) or Apartment (Apt.) number": "",
    "City": "Minneapolis",
    "State": "MN",
    "Zip Code": 55404,
    "County": "Hennepin",
    "Main phone number": "(612) 872-1152",
    "Crisis Line Phone Number": "",
    "Organization website": "openarmsmn.org",
    "Organization Email": "",
    "Hours of operation": "Monday-Friday 7:30am-5:00pm",
    "Please outline any eligibility requirements that exist to access your services (may include age, sex, residency, medical conditions, referral status, other). Do not include income or payment restrictions here.": "Potential clients need to have to be dealing with a critical illness. Program eligibility changes depending on funding. Examples included; HIV/AIDS, COPD, CHF, Cancer, ESRD, MS, ALS, Diabetes, CKD. ",
    "Please outline any payment information, insurance plans accepted, or methods of payment that your organization accepts.": "We are a free of cost to the client organization. No insurance or payment information required as long as client qualifies for programming. ",
    "Interpretation services": "We provide language interpretation. ",
    "Please provide a description of services your organization offers": "Open Arms of MN provides medically tailored meals and nutrition counseling/education to critically ill individuals. These meals are home delivered all free of cost to the client. Meal recipes are written with a registered dietitian and all meals are made from scratch in our commercial kitchens.  "
  }
]
export default hsData;